<template>
  <v-container fluid style="padding: 0 16px 0 16px;height: 100%;">
    <!-- User List Drawer -->
    <v-skeleton-loader v-if="reponseHeigth" :loading="!flagNav" transition="scale-transition" max-height="64"
      type="table-heading">
      <v-toolbar class="header-title" v-if="reponseHeigth">
        <v-toolbar-title class="title">{{ $t('_ChatService') }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
    </v-skeleton-loader>

    <v-row style="margin-top: 2rem;height: 100%;">
      <!-- <v-scroll-x-transition> -->
      <v-col v-if="showUserList && reponseWidth" cols="3" class="flex-grow-1 flex-shrink-0 pt-0">
        <div class="overflow-y-hidden fill-height view-height" style="display: flex;flex-direction: column;
          height: 100% !important;">
          <v-card style="box-shadow: none;border: 1px solid #e0e0e0;border-radius: 15px;">
            <v-tabs v-model="tab" color="primary" @update:modelValue="onTabChange" next-icon="mdi-chevron-right" 
              style="height: 55px;"
              prev-icon="mdi-chevron-left" show-arrows>
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-for="(i, index) in tabSocialType" :key="index">
                <v-badge v-if="i.unreadCount > 0" color="red" :content="i.unreadCount">
                  {{ i.text }}
                </v-badge>
                <span v-else>
                  {{ i.text }}
                </span>
              </v-tab>
            </v-tabs>
          </v-card>
          <v-card class="d-flex flex-column mt-4 pa-0"
            style="border: 1px solid #e0e0e0; border-radius: 15px; height: 100%;box-shadow: none;">
            <v-card-title style="display: flex; padding: 12px 16px;">
              <!-- Filter dropdown for desktop view -->
              <v-select
                v-model="lockFilter"
                :items="lockFilterOptions"
                variant="outlined"
                density="compact"
                hide-details
                @update:modelValue="onLockFilterChange"
                class="chatservice-filter-dropdown"
              >
                <template #selection="{ item }">
                  <div class="d-flex align-center">
                    <v-icon :color="item.raw.color" size="20" class="mr-2">{{ item.raw.icon }}</v-icon>
                    <span>{{ item.title }}</span>
                  </div>
                </template>
                <template #item="{ item, props }">
                  <v-list-item v-bind="props">
                    <template #prepend>
                      <v-icon :color="item.raw.color">{{ item.raw.icon }}</v-icon>
                    </template>
                  </v-list-item>
                </template>
              </v-select>
            </v-card-title>
            <v-card-text class="fill-height pa-0 chatservice-card-text-flex" ref="TopicContainer">
              <!-- User List Content -->
              <div v-show="!isMyLockedExpanded || myLockedTopics.length === 0" class="chatservice-skeleton-flex">
                <v-skeleton-loader :loading="loadingTopic" type="list-item-two-line" class="chatservice-skeleton-inner">
                  <!-- Empty state message when no topics are available -->
                  <v-list v-if="!(topic.length > 0)" density="compact">
                    <v-list-item>
                      No data available
                    </v-list-item>
                  </v-list>

                  <!-- Topic list with virtual scroll for performance -->
                  <v-list v-else density="compact" class="pa-0 mt-0 chatservice-topic-list-container"
                    style="height: 100%;width: 100%;">
                    <v-list-item-group v-model="selectedItem" mandatory :color="selectedColor"
                      class="chatservice-topic-list-group">
                      <v-virtual-scroll ref="scrollerMenuModel" :style="{
                        height: `${sizeTopic}dvh`,
                        borderRadius: '12px',
                        overflow: 'auto',
                        maxHeight: `${sizeTopic}dvh`
                      }" :items="filteredTopic" :item-height="67" bench="20" @scroll="TopicScroll"
                        class="chatservice-topic-virtual-scroll chatservice-scrollable">
                        <template v-slot:default="{ item, index }">
                          <div :key="`topic${index}`" :value="item.topicId" class="chatservice-topic-item-wrapper"
                               :class="{
                                 'chatservice-fade-out': fadingOutTopics.includes(item.topicID),
                                 'chatservice-fade-in': fadingInTopics.includes(item.topicID)
                               }">
                            <v-list-item :disabled="flagGetTopic"
                              @click="flagGetTopic ? '' : handleClick(item.topicID, index, item.socialType)"
                              :active="selectedItem === index"
                              :class="{ 'chatservice-topic-selected': selectedItem === index }"
                              class="chatservice-topic-list-item">
                              <template #prepend>
                                <v-badge v-if="item.unread || item.statusContactAgent === 'C-Close' || item.statusContactAgent === 'C-Active'"
                                  :color="item.unread ? 'red' : (item.statusContactAgent === 'C-Close' ? 'grey-darken-2' : 'success')"
                                  :content="item.unread ? '!' : undefined"
                                  :icon="!item.unread && item.statusContactAgent === 'C-Close' ? 'mdi-power-plug-off' : (!item.unread && item.statusContactAgent === 'C-Active' ? 'mdi-power-plug' : undefined)"
                                  bordered overlap
                                  class="chatservice-topic-badge">
                                  <v-avatar size="40" class="chatservice-topic-avatar"
                                    :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                                    <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                      : item.socialType == 'Instagram' ? logoBrand.instagram
                                        : item.socialType == 'Line' ? logoBrand.line
                                        : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                                  </v-avatar>
                                </v-badge>
                                <v-avatar v-else size="40" class="chatservice-topic-avatar"
                                  :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                                  <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                    : item.socialType == 'Instagram' ? logoBrand.instagram
                                      : item.socialType == 'Line' ? logoBrand.line
                                      : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                                </v-avatar>
                              </template>

                              <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                              <v-list-item-subtitle class="chatservice-topic-subtitle">
                                {{ item.latestMsg }}
                              </v-list-item-subtitle>
                              <!-- Wealth Membership Badge -->
                              <v-chip
                                v-if="item.wealthMembership"
                                size="x-small"
                                :color="getWealthColor(item.wealthMembership)"
                                variant="flat"
                                class="mt-1"
                                style="width: fit-content;"
                              >
                                <v-icon start size="10">{{ getWealthIcon(item.wealthMembership) }}</v-icon>
                                {{ item.wealthMembership }}
                              </v-chip>

                              <template #append>
                                <div class="d-flex flex-column align-end">
                                  <span class="text-caption text-grey mb-1">{{ formatUpdateDate(item.updateDate) }}</span>
                                  <!-- Reserve button when not locked (and not closed) -->
                                  <v-btn v-if="canEdit && !isTopicLocked(item.topicID) && item.statusContactAgent !== 'C-Close'"
                                         size="small"
                                         variant="tonal"
                                         color="primary"
                                         @click.stop="quickAcquireLock(item.topicID)">
                                    <v-icon start size="16">mdi-lock-open</v-icon>
                                    จอง
                                  </v-btn>
                                  <!-- Show locker name when locked (and not closed) -->
                                  <v-chip v-else-if="item.statusContactAgent !== 'C-Close'"
                                          size="small"
                                          :color="isLockedByMe(item.topicID) ? 'success' : 'warning'"
                                          variant="flat">
                                    <v-icon start size="14">mdi-lock</v-icon>
                                    {{ getLockDisplayName(item.topicID) }}
                                  </v-chip>
                                </div>
                              </template>
                            </v-list-item>

                            <v-divider :key="`chatDivider${index}`" class="chatservice-topic-divider" />
                          </div>
                        </template>
                      </v-virtual-scroll>
                    </v-list-item-group>
                  </v-list>
                </v-skeleton-loader>
              </div>

              <!-- My Locked Topics Section -->
              <div v-if="myLockedTopics.length > 0" class="chatservice-my-locked-section mx-2 mb-2" :class="isMyLockedExpanded ? 'mt-0' : 'mt-2'" :style="{ flex: isMyLockedExpanded ? '1 1 0' : '0 0 auto', display: 'flex', flexDirection: 'column', height: isMyLockedExpanded ? '100%' : 'auto', overflow: 'hidden', transition: 'all 0.3s ease' }">
                <div @click="isMyLockedExpanded = !isMyLockedExpanded" class="d-flex align-center px-3 py-2" style="background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%); border-radius: 8px 8px 0 0; cursor: pointer; transition: background 0.3s;" onmouseover="this.style.background='linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%)'" onmouseout="this.style.background='linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)'">
                  <v-icon color="success" size="18" class="mr-2">mdi-lock-check</v-icon>
                  <span class="text-body-2 font-weight-medium" style="color: #2e7d32;">ที่คุณจองไว้</span>
                  <v-chip size="x-small" color="success" variant="flat" class="ml-2">{{ myLockedTopics.length }}</v-chip>
                  <v-spacer></v-spacer>
                  <v-icon color="success" size="20" style="transition: transform 0.3s" :style="{ transform: isMyLockedExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }">mdi-chevron-up</v-icon>
                </div>
                <v-list v-show="isMyLockedExpanded" density="compact" class="pa-0 chatservice-my-locked-list flex-grow-1 overflow-y-auto" @scroll="MyLockedTopicScroll">
                  <template v-for="(item, index) in myLockedTopics" :key="`myLocked${index}`">
                    <div class="chatservice-topic-item-wrapper"
                         :class="{ 
                           'chatservice-fade-out': fadingOutMyLockedTopics.includes(item.topicID), 
                           'chatservice-fade-in': fadingInMyLockedTopics.includes(item.topicID)
                         }">
                      <v-list-item :disabled="flagGetTopic"
                        @click="flagGetTopic ? '' : handleClickMyLocked(item.topicID, index, item.socialType)"
                        :active="currentTopicId === item.topicID"
                        :class="{ 'chatservice-topic-selected': currentTopicId === item.topicID }"
                        class="chatservice-topic-list-item">
                        <template #prepend>
                          <v-badge v-if="item.unread || item.statusContactAgent === 'C-Close' || item.statusContactAgent === 'C-Active'" 
                            :color="item.unread ? 'red' : (item.statusContactAgent === 'C-Close' ? 'grey-darken-2' : 'success')" 
                            :content="item.unread ? '!' : undefined" 
                            :icon="!item.unread && item.statusContactAgent === 'C-Close' ? 'mdi-power-plug-off' : (!item.unread && item.statusContactAgent === 'C-Active' ? 'mdi-power-plug' : undefined)" 
                            bordered overlap class="chatservice-topic-badge">
                            <v-avatar size="40" class="chatservice-topic-avatar"
                              :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                              <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                : item.socialType == 'Instagram' ? logoBrand.instagram
                                  : item.socialType == 'Line' ? logoBrand.line
                                  : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                            </v-avatar>
                          </v-badge>
                          <v-avatar v-else size="40" class="chatservice-topic-avatar"
                            :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                            <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                              : item.socialType == 'Instagram' ? logoBrand.instagram
                                : item.socialType == 'Line' ? logoBrand.line
                                : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                          </v-avatar>
                        </template>

                        <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                        <v-list-item-subtitle class="chatservice-topic-subtitle">{{ item.latestMsg }}</v-list-item-subtitle>
                        <v-chip v-if="item.wealthMembership" size="x-small" :color="getWealthColor(item.wealthMembership)" variant="flat" class="mt-1" style="width: fit-content;">
                          <v-icon start size="10">{{ getWealthIcon(item.wealthMembership) }}</v-icon>
                          {{ item.wealthMembership }}
                        </v-chip>
                        
                        <template #append>
                          <div class="d-flex flex-column align-end">
                            <span class="text-caption text-grey mb-1">{{ formatUpdateDate(item.updateDate) }}</span>
                            <v-btn v-if="canEdit" size="small" variant="tonal" color="error" @click.stop="releaseLockFromList(item.topicID)">
                              <v-icon start size="16">mdi-lock-open-variant</v-icon>
                              ปลด
                            </v-btn>
                          </div>
                        </template>
                      </v-list-item>
                      <v-divider class="chatservice-topic-divider" />
                    </div>
                  </template>
                </v-list>
              </div>

              <!-- Closed Topics Section (ลูกค้าออกจากแชทแล้ว) -->
              <div v-if="closedTopics.length > 0" class="chatservice-my-locked-section mx-2 mb-2" :class="isClosedExpanded ? 'mt-0' : 'mt-2'" :style="{ flex: isClosedExpanded ? '1 1 0' : '0 0 auto', display: 'flex', flexDirection: 'column', height: isClosedExpanded ? '100%' : 'auto', overflow: 'hidden', transition: 'all 0.3s ease' }">
                <div @click="isClosedExpanded = !isClosedExpanded" class="d-flex align-center px-3 py-2" style="background: linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%); border-radius: 8px 8px 0 0; cursor: pointer; transition: background 0.3s;" onmouseover="this.style.background='linear-gradient(135deg, #f8bbd0 0%, #f48fb1 100%)'" onmouseout="this.style.background='linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%)'">
                  <v-icon color="grey-darken-2" size="18" class="mr-2">mdi-power-plug-off</v-icon>
                  <span class="text-body-2 font-weight-medium" style="color: #c62828;">ลูกค้าออกจากแชทแล้ว</span>
                  <v-chip size="x-small" color="grey-darken-2" variant="flat" class="ml-2">{{ closedTopics.length }}</v-chip>
                  <v-spacer></v-spacer>
                  <v-icon color="grey-darken-2" size="20" style="transition: transform 0.3s" :style="{ transform: isClosedExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }">mdi-chevron-up</v-icon>
                </div>
                <v-list v-show="isClosedExpanded" density="compact" class="pa-0 chatservice-my-locked-list flex-grow-1 overflow-y-auto">
                  <template v-for="(item, index) in closedTopics" :key="`closed${index}`">
                    <div class="chatservice-topic-item-wrapper"
                         :class="{ 
                           'chatservice-fade-out': fadingOutClosedTopics.includes(item.topicID), 
                           'chatservice-fade-in': fadingInClosedTopics.includes(item.topicID)
                         }">
                      <v-list-item :disabled="flagGetTopic"
                        @click="flagGetTopic ? '' : handleClickClosed(item.topicID, index, item.socialType)"
                        :active="currentTopicId === item.topicID"
                        :class="{ 'chatservice-topic-selected': currentTopicId === item.topicID }"
                        class="chatservice-topic-list-item">
                        <template #prepend>
                          <v-badge color="grey-darken-2" icon="mdi-power-plug-off" bordered overlap class="chatservice-topic-badge">
                            <v-avatar size="40" class="chatservice-topic-avatar"
                              :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                              <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                : item.socialType == 'Instagram' ? logoBrand.instagram
                                  : item.socialType == 'Line' ? logoBrand.line
                                  : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                            </v-avatar>
                          </v-badge>
                        </template>

                        <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                        <v-list-item-subtitle class="chatservice-topic-subtitle">{{ item.latestMsg }}</v-list-item-subtitle>
                        <v-chip v-if="item.wealthMembership" size="x-small" :color="getWealthColor(item.wealthMembership)" variant="flat" class="mt-1" style="width: fit-content;">
                          <v-icon start size="10">{{ getWealthIcon(item.wealthMembership) }}</v-icon>
                          {{ item.wealthMembership }}
                        </v-chip>
                        
                        <template #append>
                          <div class="d-flex flex-column align-end">
                            <span class="text-caption text-grey mb-1">{{ formatUpdateDate(item.updateDate) }}</span>
                            <!-- Reserve button for closed topics -->
                            <v-btn v-if="canEdit && !isTopicLocked(item.topicID)"
                                   size="small"
                                   variant="tonal"
                                   color="primary"
                                   @click.stop="quickAcquireLock(item.topicID)">
                              <v-icon start size="16">mdi-lock-open</v-icon>
                              จอง
                            </v-btn>
                            <v-chip v-else
                                    size="small" 
                                    :color="isLockedByMe(item.topicID) ? 'success' : 'warning'" 
                                    variant="flat">
                              <v-icon start size="14">mdi-lock</v-icon>
                              {{ getLockDisplayName(item.topicID) }}
                            </v-chip>
                          </div>
                        </template>
                      </v-list-item>
                      <v-divider class="chatservice-topic-divider" />
                    </div>
                  </template>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <!-- </v-scroll-x-transition> -->
      <!-- Chat Section -->
      <!-- <v-col >
          </v-col> -->
      <!-- <v-dialog v-model="showUserList" v-if="!showUserList && !$vuetify.breakpoint.smAndUp"> -->
      <v-slide-x-transition>
        <v-col cols="12" v-show="!showUserList && !reponseWidth" class="flex-grow-1 flex-shrink-0 pt-0">
          <v-responsive class="overflow-y-hidden fill-height view-height">
            <!-- Tabs section with responsive enhancements -->
            <v-card style="box-shadow: none;border: 1px solid #e0e0e0;border-radius: 15px;">
              <v-tabs v-model="tab" color="primary" @update:modelValue="onTabChange" next-icon="mdi-chevron-right" style="height: 55px;"
                prev-icon="mdi-chevron-left" show-arrows>
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="(i, index) in tabSocialType" :key="index">
                  <v-badge v-if="i.unreadCount > 0" color="red" :content="i.unreadCount">
                    {{ i.text }}
                  </v-badge>
                  <span v-else>
                    {{ i.text }}
                  </span>
                </v-tab>
              </v-tabs>
            </v-card>

            <!-- Main chat container with improved responsive layout -->
            <v-card class="d-flex flex-column fill-height mt-4"
              style="border: 1px solid #e0e0e0; border-radius: 15px; height: 100%;width: 100%;box-shadow: none;">
              <v-card-title style="display: flex; padding: 12px 16px;">
                <!-- Filter dropdown for mobile view -->
                <v-select
                  v-model="lockFilter"
                  :items="lockFilterOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  @update:modelValue="onLockFilterChange"
                  class="chatservice-filter-dropdown"
                  style="flex: 1;"
                >
                  <template #selection="{ item }">
                    <div class="d-flex align-center">
                      <v-icon :color="item.raw.color" size="20" class="mr-2">{{ item.raw.icon }}</v-icon>
                      <span>{{ item.title }}</span>
                    </div>
                  </template>
                  <template #item="{ item, props }">
                    <v-list-item v-bind="props">
                      <template #prepend>
                        <v-icon :color="item.raw.color">{{ item.raw.icon }}</v-icon>
                      </template>
                    </v-list-item>
                  </template>
                </v-select>

                <!-- Toggle user list button with responsive styling -->
                <v-app-bar-nav-icon style="cursor: pointer;" :style="{
                  color: `#${NavbarBtnColorTheme || '5179ef'}`
                }" @click="toggleUserList" aria-label="Toggle user list"></v-app-bar-nav-icon>
              </v-card-title>

              <!-- Chat list with enhanced responsive skeleton loader -->
              <v-card-text class="fill-height pa-0 chatservice-card-text-flex" ref="TopicContainer">
                <div v-show="!isMyLockedExpanded || myLockedTopics.length === 0" class="chatservice-skeleton-flex">
                  <v-skeleton-loader :loading="loadingTopic" type="list-item-two-line" class="chatservice-skeleton-inner">
                    <!-- Empty state message when no topics are available -->
                    <v-list v-if="!(topic.length > 0)" density="compact">
                      <v-list-item>
                        No data available
                      </v-list-item>
                    </v-list>

                    <!-- Topic list with virtual scroll for performance -->
                    <v-list v-else density="compact" class="pa-0 mt-0 chatservice-topic-list-container"
                      style="height: 100%;width: 100%;">
                      <v-list-item-group v-model="selectedItem" mandatory :color="selectedColor"
                        class="chatservice-topic-list-group">
                        <v-virtual-scroll ref="scrollerMenuModel" :style="{
                          height: `${sizeTopic}dvh`,
                          borderRadius: '12px',
                          overflow: 'auto',
                          maxHeight: `${sizeTopic}dvh`
                        }" :items="filteredTopic" :item-height="67" bench="20" @scroll="TopicScroll"
                          class="chatservice-topic-virtual-scroll chatservice-scrollable">
                          <template v-slot:default="{ item, index }">
                            <div :key="`topic${index}`" :value="item.topicId" class="chatservice-topic-item-wrapper"
                                 :class="{
                                   'chatservice-fade-out': fadingOutTopics.includes(item.topicID),
                                   'chatservice-fade-in': fadingInTopics.includes(item.topicID)
                                 }">
                              <v-list-item :disabled="flagGetTopic"
                                @click="flagGetTopic ? '' : handleClick(item.topicID, index, item.socialType)"
                                :active="selectedItem === index"
                                :class="{ 'chatservice-topic-selected': selectedItem === index }"
                                class="chatservice-topic-list-item">
                                <template #prepend>
                                  <v-badge v-if="item.unread || item.statusContactAgent === 'C-Close' || item.statusContactAgent === 'C-Active'"
                                    :color="item.unread ? 'red' : (item.statusContactAgent === 'C-Close' ? 'grey-darken-2' : 'success')"
                                    :content="item.unread ? '!' : undefined"
                                    :icon="!item.unread && item.statusContactAgent === 'C-Close' ? 'mdi-power-plug-off' : (!item.unread && item.statusContactAgent === 'C-Active' ? 'mdi-power-plug' : undefined)"
                                    bordered overlap
                                    class="chatservice-topic-badge">
                                    <v-avatar size="40" class="chatservice-topic-avatar"
                                      :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                                      <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                        : item.socialType == 'Instagram' ? logoBrand.instagram
                                          : item.socialType == 'Line' ? logoBrand.line
                                          : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain"/>
                                    </v-avatar>
                                  </v-badge>
                                  <v-avatar v-else size="40" class="chatservice-topic-avatar"
                                    :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                                    <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                      : item.socialType == 'Instagram' ? logoBrand.instagram
                                        : item.socialType == 'Line' ? logoBrand.line
                                        : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain"/>
                                  </v-avatar>
                                </template>

                                <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                                <v-list-item-subtitle class="chatservice-topic-subtitle">
                                  {{ item.latestMsg }}
                                </v-list-item-subtitle>
                                <!-- Wealth Membership Badge -->
                                <v-chip
                                  v-if="item.wealthMembership"
                                  size="x-small"
                                  :color="getWealthColor(item.wealthMembership)"
                                  variant="flat"
                                  class="mt-1"
                                  style="width: fit-content;"
                                >
                                  <v-icon start size="10">{{ getWealthIcon(item.wealthMembership) }}</v-icon>
                                  {{ item.wealthMembership }}
                                </v-chip>

                                <template #append>
                                  <div class="d-flex flex-column align-end">
                                    <span class="text-caption text-grey mb-1">{{ formatUpdateDate(item.updateDate) }}</span>
                                    <!-- Reserve button when not locked -->
                                    <v-btn v-if="canEdit && !isTopicLocked(item.topicID) && item.statusContactAgent !== 'C-Close'"
                                           size="small"
                                           variant="tonal"
                                           color="primary"
                                           @click.stop="quickAcquireLock(item.topicID)">
                                      <v-icon start size="16">mdi-lock-open</v-icon>
                                      จอง
                                    </v-btn>
                                    <!-- Show locker name when locked -->
                                    <v-chip v-else-if="item.statusContactAgent !== 'C-Close'"
                                            size="small"
                                            :color="isLockedByMe(item.topicID) ? 'success' : 'warning'"
                                            variant="flat">
                                      <v-icon start size="14">mdi-lock</v-icon>
                                      {{ getLockDisplayName(item.topicID) }}
                                    </v-chip>
                                  </div>
                                </template>
                              </v-list-item>

                              <v-divider :key="`chatDivider${index}`" class="chatservice-topic-divider" />
                            </div>
                          </template>
                        </v-virtual-scroll>
                      </v-list-item-group>
                    </v-list>
                  </v-skeleton-loader>
                </div>

                <!-- My Locked Topics Section for Mobile -->
                <div v-if="myLockedTopics.length > 0" class="chatservice-my-locked-section mx-2 mb-2" :class="isMyLockedExpanded ? 'mt-0' : 'mt-2'" :style="{ flex: isMyLockedExpanded ? '1 1 0' : '0 0 auto', display: 'flex', flexDirection: 'column', height: isMyLockedExpanded ? '100%' : 'auto', overflow: 'hidden', transition: 'all 0.3s ease' }">
                  <div @click="isMyLockedExpanded = !isMyLockedExpanded" class="d-flex align-center px-3 py-2" style="background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%); border-radius: 8px 8px 0 0; cursor: pointer; transition: background 0.3s;" onmouseover="this.style.background='linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%)'" onmouseout="this.style.background='linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)'">
                    <v-icon color="success" size="18" class="mr-2">mdi-lock-check</v-icon>
                    <span class="text-body-2 font-weight-medium" style="color: #2e7d32;">ที่คุณจองไว้</span>
                    <v-chip size="x-small" color="success" variant="flat" class="ml-2">{{ myLockedTopics.length }}</v-chip>
                    <v-spacer></v-spacer>
                    <v-icon color="success" size="20" style="transition: transform 0.3s" :style="{ transform: isMyLockedExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }">mdi-chevron-up</v-icon>
                  </div>
                  <v-list v-show="isMyLockedExpanded" density="compact" class="pa-0 chatservice-my-locked-list flex-grow-1 overflow-y-auto" @scroll="MyLockedTopicScroll">
                    <template v-for="(item, index) in myLockedTopics" :key="`mobileMyLocked${index}`">
                      <div class="chatservice-topic-item-wrapper"
                           :class="{ 
                             'chatservice-fade-out': fadingOutMyLockedTopics.includes(item.topicID), 
                             'chatservice-fade-in': fadingInMyLockedTopics.includes(item.topicID)
                           }">
                        <v-list-item :disabled="flagGetTopic"
                          @click="flagGetTopic ? '' : handleClickMyLocked(item.topicID, index, item.socialType)"
                          :active="currentTopicId === item.topicID"
                          :class="{ 'chatservice-topic-selected': currentTopicId === item.topicID }"
                          class="chatservice-topic-list-item">
                          <template #prepend>
                            <v-badge v-if="item.unread || item.statusContactAgent === 'C-Close' || item.statusContactAgent === 'C-Active'" 
                              :color="item.unread ? 'red' : (item.statusContactAgent === 'C-Close' ? 'grey-darken-2' : 'success')" 
                              :content="item.unread ? '!' : undefined" 
                              :icon="!item.unread && item.statusContactAgent === 'C-Close' ? 'mdi-power-plug-off' : (!item.unread && item.statusContactAgent === 'C-Active' ? 'mdi-power-plug' : undefined)" 
                              bordered overlap class="chatservice-topic-badge">
                              <v-avatar size="40" class="chatservice-topic-avatar"
                                :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                                <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                  : item.socialType == 'Instagram' ? logoBrand.instagram
                                    : item.socialType == 'Line' ? logoBrand.line
                                    : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                              </v-avatar>
                            </v-badge>
                            <v-avatar v-else size="40" class="chatservice-topic-avatar"
                              :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                              <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                : item.socialType == 'Instagram' ? logoBrand.instagram
                                  : item.socialType == 'Line' ? logoBrand.line
                                  : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                            </v-avatar>
                          </template>

                          <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                          <v-list-item-subtitle class="chatservice-topic-subtitle">{{ item.latestMsg }}</v-list-item-subtitle>
                          <v-chip v-if="item.wealthMembership" size="x-small" :color="getWealthColor(item.wealthMembership)" variant="flat" class="mt-1" style="width: fit-content;">
                            <v-icon start size="10">{{ getWealthIcon(item.wealthMembership) }}</v-icon>
                            {{ item.wealthMembership }}
                          </v-chip>
                          
                          <template #append>
                            <div class="d-flex flex-column align-end">
                              <span class="text-caption text-grey mb-1">{{ formatUpdateDate(item.updateDate) }}</span>
                              <v-btn v-if="canEdit" size="small" variant="tonal" color="error" @click.stop="releaseLockFromList(item.topicID)">
                                <v-icon start size="16">mdi-lock-open-variant</v-icon>
                                ปลด
                              </v-btn>
                            </div>
                          </template>
                        </v-list-item>
                        <v-divider class="chatservice-topic-divider" />
                      </div>
                    </template>
                  </v-list>
                </div>

                <!-- Closed Topics Section for Mobile (ลูกค้าออกจากแชทแล้ว) -->
                <div v-if="closedTopics.length > 0" class="chatservice-my-locked-section mx-2 mb-2" :class="isClosedExpanded ? 'mt-0' : 'mt-2'" :style="{ flex: isClosedExpanded ? '1 1 0' : '0 0 auto', display: 'flex', flexDirection: 'column', height: isClosedExpanded ? '100%' : 'auto', overflow: 'hidden', transition: 'all 0.3s ease' }">
                  <div @click="isClosedExpanded = !isClosedExpanded" class="d-flex align-center px-3 py-2" style="background: linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%); border-radius: 8px 8px 0 0; cursor: pointer; transition: background 0.3s;" onmouseover="this.style.background='linear-gradient(135deg, #f8bbd0 0%, #f48fb1 100%)'" onmouseout="this.style.background='linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%)'">
                    <v-icon color="grey-darken-2" size="18" class="mr-2">mdi-power-plug-off</v-icon>
                    <span class="text-body-2 font-weight-medium" style="color: #c62828;">ลูกค้าออกจากแชทแล้ว</span>
                    <v-chip size="x-small" color="grey-darken-2" variant="flat" class="ml-2">{{ closedTopics.length }}</v-chip>
                    <v-spacer></v-spacer>
                    <v-icon color="grey-darken-2" size="20" style="transition: transform 0.3s" :style="{ transform: isClosedExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }">mdi-chevron-up</v-icon>
                  </div>
                  <v-list v-show="isClosedExpanded" density="compact" class="pa-0 chatservice-my-locked-list flex-grow-1 overflow-y-auto">
                    <template v-for="(item, index) in closedTopics" :key="`mobileClosed${index}`">
                      <div class="chatservice-topic-item-wrapper"
                           :class="{ 
                             'chatservice-fade-out': fadingOutClosedTopics.includes(item.topicID), 
                             'chatservice-fade-in': fadingInClosedTopics.includes(item.topicID)
                           }">
                        <v-list-item :disabled="flagGetTopic"
                          @click="flagGetTopic ? '' : handleClickClosed(item.topicID, index, item.socialType)"
                          :active="currentTopicId === item.topicID"
                          :class="{ 'chatservice-topic-selected': currentTopicId === item.topicID }"
                          class="chatservice-topic-list-item">
                          <template #prepend>
                            <v-badge color="grey-darken-2" icon="mdi-power-plug-off" bordered overlap class="chatservice-topic-badge">
                              <v-avatar size="40" class="chatservice-topic-avatar"
                                :color="item.socialType == 'Line' ? 'green-accent-3' : item.socialType == 'LHB' ? 'white' : 'light-blue'">
                                <v-img :src="item.socialType == 'Facebook' ? logoBrand.facebook
                                  : item.socialType == 'Instagram' ? logoBrand.instagram
                                    : item.socialType == 'Line' ? logoBrand.line
                                    : item.socialType == 'LHB' ? logoBrand.logoLHB : ''" class="logo-contain" />
                              </v-avatar>
                            </v-badge>
                          </template>

                          <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                          <v-list-item-subtitle class="chatservice-topic-subtitle">{{ item.latestMsg }}</v-list-item-subtitle>
                          <v-chip v-if="item.wealthMembership" size="x-small" :color="getWealthColor(item.wealthMembership)" variant="flat" class="mt-1" style="width: fit-content;">
                            <v-icon start size="10">{{ getWealthIcon(item.wealthMembership) }}</v-icon>
                            {{ item.wealthMembership }}
                          </v-chip>
                          
                          <template #append>
                            <div class="d-flex flex-column align-end">
                              <span class="text-caption text-grey mb-1">{{ formatUpdateDate(item.updateDate) }}</span>
                              <v-btn v-if="canEdit && !isTopicLocked(item.topicID)"
                                     size="small"
                                     variant="tonal"
                                     color="primary"
                                     @click.stop="quickAcquireLock(item.topicID)">
                                <v-icon start size="16">mdi-lock-open</v-icon>
                                จอง
                              </v-btn>
                              <v-chip v-else
                                      size="small" 
                                      :color="isLockedByMe(item.topicID) ? 'success' : 'warning'" 
                                      variant="flat">
                                <v-icon start size="14">mdi-lock</v-icon>
                                {{ getLockDisplayName(item.topicID) }}
                              </v-chip>
                            </div>
                          </template>
                        </v-list-item>
                        <v-divider class="chatservice-topic-divider" />
                      </div>
                    </template>
                  </v-list>
                </div>
              </v-card-text>
            </v-card>
          </v-responsive>
        </v-col>
      </v-slide-x-transition>
      <!-- </v-dialog> -->
      <!-- <v-slide-x-reverse-transition hide-on-leave> -->
      <v-col :cols="showUserList && reponseWidth ? 9 : 12" v-show="!reponseWidth ? showUserList : true"
        class="flex-grow-1 flex-shrink-0 pt-0">
        <v-responsive class="overflow-y-hidden fill-height view-height">
          <!-- h-fill-available -->
          <v-card class="d-flex flex-column fill-height"
            style="border:  1px solid #e0e0e0; border-radius: 12px;box-shadow: none;">
            <v-skeleton-loader :loading="loadingUsername" type="card-heading">
              <v-card-title class="d-flex align-center justify-space-between"
                style="width: 100%;border-bottom: 1px solid #e0e0e0;">
                <div class="d-flex flex-column">
                  <span>{{ user ? user : 'User not selected' }}</span>
                  <!-- Wealth Membership Badge -->
                  <v-chip
                    v-if="user && currentTopic && currentTopic.wealthMembership"
                    size="x-small"
                    :color="wealthMembershipColor"
                    variant="flat"
                    class="mt-1"
                    style="width: fit-content;"
                  >
                    <v-icon start size="12">{{ wealthMembershipIcon }}</v-icon>
                    {{ currentTopic.wealthMembership }}
                  </v-chip>
                </div>
                <div class="d-flex align-center">
                  <!-- C-Close Status Badge -->
                  <v-chip
                    v-if="user && currentTopic && currentTopic.statusContactAgent === 'C-Close'"
                    size="small"
                    color="error"
                    variant="tonal"
                    class="mr-2 px-3 font-weight-medium"
                    style="border-radius: 8px;"
                  >
                    <v-icon start size="14">mdi-account-cancel-outline</v-icon>
                    ลูกค้าออกจากแชทแล้ว
                  </v-chip>

                  <!-- Lock Badge (show only when topic is locked) - LEFT of button -->
                  <v-chip
                    v-if="user && currentTopic && currentTopic.lockedBy && currentTopic.statusContactAgent !== 'C-Close'"
                    size="small"
                    :color="isCurrentTopicLockedByMe ? 'success' : 'warning'"
                    variant="flat"
                    class="mr-2"
                  >
                    <v-icon start size="14">mdi-lock</v-icon>
                    {{ isCurrentTopicLockedByMe ? 'ฉัน' : currentLockInfo?.lockedByName || 'แอดมิน' }}
                  </v-chip>
                  
                  <!-- Bot Button (show only when Admin mode AND locked by me) -->
                  <v-btn
                    v-if="user && currentTopic && isCurrentTopicLockedByMe || currentTopic?.statusContactAgent == 'C-Close'"
                    size="small"
                    variant="tonal"
                    color="primary"
                    class="mr-2"
                    @click.stop="handleSwitchChange(currentTopicId, currentTopic.adminReply)"
                  >
                    <v-icon start size="16">mdi-robot</v-icon>
                    นำออกจาก Chat
                  </v-btn>
                  
                  <v-app-bar-nav-icon style="cursor: pointer;" :style="{ color: `#${NavbarBtnColorTheme || '5179ef'}` }"
                    @click="toggleUserList">
                  </v-app-bar-nav-icon>
                </div>
              </v-card-title>
              
              <!-- Lock Banner - Locked by others (warning) -->
              <!-- <v-alert 
                v-if="isCurrentTopicLockedByOther"
                type="warning"
                density="compact"
                class="ma-2 mb-0"
                border="start"
                variant="tonal">
                <template #prepend>
                  <v-icon>mdi-lock-alert</v-icon>
                </template>
                <div class="d-flex align-center justify-space-between">
                  <span>ห้องนี้กำลังถูกดูแลโดย <strong>{{ currentLockInfo?.lockedByName }}</strong></span>
                </div>
              </v-alert>
               -->
              <!-- Lock Banner - Locked by me (success) - Only unlock button -->
              <v-alert 
                v-if="isCurrentTopicLockedByMe"
                type="success"
                density="compact"
                class="ma-2 mb-0 chatservice-lock-alert"
                border="start"
                variant="tonal">
                <template #prepend>
                  <v-icon>mdi-lock-check</v-icon>
                </template>
                <div class="d-flex align-center justify-end">
                  <v-btn size="small" variant="text" color="success" @click="releaseLock" :loading="isLocking">
                    <v-icon start>mdi-lock-open</v-icon>
                    ปลดล็อค
                  </v-btn>
                </div>
              </v-alert>
            </v-skeleton-loader>
            <v-row class="ma-0 ">
              <v-col cols="12" v-if="loadingMessage" class="py-0" style="height: 100vh;position: sticky;">
                <v-progress-linear indeterminate :color="selectedColor" class="mb-0"></v-progress-linear>
              </v-col>
            </v-row>
            <v-skeleton-loader class="flex-grow-1 pa-4" v-if="StartupLoadingMessage"
              type="list-item-three-line,list-item-two-line">
            </v-skeleton-loader>
            <v-card-text class="flex-grow-1 overflow-y-auto pt-2" ref="scrollContainer" @scroll="ChatScreScroll"
              v-if="user" style="position: relative;">
              <!-- Chat Messages -->
              <div v-for="(msg, index) in messages" :id="'ChatId_' + msg.id" :key="index">
                <div v-if="msg.messageUser != null" class="chat-box d-flex"
                  style="display: flex !important;align-items: flex-start;flex-direction: column;">
                  <sub class="ml-1 mb-3" style="font-size: 10px;">{{ msg.requestTime }}</sub>
                  <div class="message pa-4 mb-5" style="line-break: anywhere;
                        padding: 0px 4px;
                        border-radius: 1px 20px 20px 20px;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 22px;
                        display: flex;
                        width: fit-content;
                        float: right;
                        background-color: #E0E0E0;
                        min-height: 35px;max-width: 80%;  margin-top:2px;  margin-right: 6px;">
                    <MarkdownRenderer :content="msg.messageUser" />
                  </div>
                </div>
                <div v-if="msg.messageBot != null" class="chat-box d-flex"
                  style="display: flex !important;justify-content: flex-end;flex-direction: column; align-items: flex-end;">
                  <sub class="mr-2 mb-3" style="font-size: 10px;">
                    <span v-if="msg.adminName" class="font-weight-medium mr-1">{{ msg.adminName }} •</span>
                    {{ msg.responseTime }}
                  </sub>
                  <div class="message pa-4 mb-5 white--text" :color="selectedColor + 'DD'" style="line-break: anywhere;
                        padding: 0px 4px;
                        border-radius: 20px 1px 20px 20px;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 22px;
                        display: flex;
                        width: fit-content;
                        float: right;
                        min-height: 35px;max-width: 80%;  margin-top:2px;  margin-right: 6px;"
                    :style="{ backgroundColor: selectedColor + 'DD' }">
                    <MarkdownRenderer :content="msg.messageBot" />
                  </div>
                </div>
              </div>
            </v-card-text>
            <!-- Reload Overlay -->
            <v-card-text class="flex-grow-1 pt-2" v-if="showReloadButton" style="height: 100vh; display: flex; justify-content: center; align-items: center;">
              <div class="reload-overlay">
                <v-btn
                  variant="flat"
                  size="x-large"
                  :disabled="loadingMessage"
                  :loading="loadingMessage"
                  @click="reloadMessages"
                  icon="mdi-refresh"
                  class="reload-glass-btn"
                />
              </div>
            </v-card-text>
            <v-card-text class="flex-shrink-1" style="display: flex;align-items: end;" v-else-if="(topic.length > 0 || myLockedTopics.length > 0 || closedTopics.length > 0) && user && !showReloadButton">
              
              <!-- Closed contact notification (replaces input area) -->
              <div v-if="isCurrentTopicContactClosed" class="chatservice-status-card chatservice-status-card-closed">
                <div class="chatservice-status-card-icon">
                  <v-icon size="22">mdi-account-cancel-outline</v-icon>
                </div>
                <div class="chatservice-status-card-content">
                  <div class="chatservice-status-card-title">ลูกค้าได้ยกเลิกการติดต่อเจ้าหน้าที่แล้ว</div>
                  <div class="chatservice-status-card-subtitle">ไม่สามารถส่งข้อความเพิ่มเติมในห้องสนทนานี้ได้</div>
                </div>
              </div>

              <!-- Lock Notification Bar - Not locked yet (replaces input) -->
              <div v-else-if="isCurrentTopicNotLocked" class="chatservice-lock-bar chatservice-lock-bar-default">
                <v-icon size="20" class="mr-2">mdi-lock-open-outline</v-icon>
                <span class="flex-grow-1">ห้องนี้ยังไม่ได้ถูกจอง คลิกเพื่อจองห้องนี้</span>
                <v-btn v-if="canEdit" color="primary" variant="flat" @click="acquireLock" :loading="isLocking">
                  <v-icon start>mdi-lock</v-icon>
                  จองห้อง
                </v-btn>
              </div>
              
              <!-- Lock Notification Bar - Locked by others (replaces input) -->
              <div v-else-if="isCurrentTopicLockedByOther" class="chatservice-lock-bar chatservice-lock-bar-warning">
                <v-icon size="20" class="mr-2">mdi-lock-alert</v-icon>
                <span class="flex-grow-1">ห้องนี้กำลังถูกดูแลโดย <strong>{{ currentLockInfo?.lockedByName }}</strong></span>
                <v-btn v-if="canEdit" color="warning" variant="flat" @click="confirmTakeOverLock" :loading="isLocking">
                  <v-icon start>mdi-lock-reset</v-icon>
                  รับช่วงต่อ
                </v-btn>
              </div>
              
              <!-- Normal Input Area (only shown when locked by me) -->
              <div v-else class="chatservice-input-container">
                <!-- File preview section -->
                <div v-if="previews.length > 0" class="chatservice-file-preview-section">
                  <div class="chatservice-file-preview-grid">
                    <div v-for="(file, index) in previews" :key="index" class="chatservice-file-preview-item">
                      <div class="chatservice-file-preview-card">
                        <v-img :src="file.src" class="chatservice-file-preview-image" height="60" width="60" cover />
                        <div class="chatservice-file-preview-overlay">
                          <v-btn size="small" icon="mdi-close" variant="elevated" color="error"
                            @click="removeFile(index)" class="chatservice-file-remove-btn" />
                        </div>
                      </div>
                      <v-tooltip :text="file.filename" location="top">
                        <template v-slot:activator="{ props }">
                          <div v-bind="props" class="chatservice-file-name">
                            {{ file.filename }}
                          </div>
                        </template>
                      </v-tooltip>
                    </div>

                    <!-- Add more files button -->
                    <div v-if="previews.length > 0" class="chatservice-file-preview-item">
                      <v-btn variant="outlined" color="primary" size="large" icon="mdi-plus"
                        class="chatservice-add-more-btn" @click="onButtonClick($event), filesMore = true" />
                    </div>
                  </div>
                </div>

                <!-- Main input area -->
                <div class="chatservice-input-wrapper">
                  <!-- File upload button -->
                  <v-btn variant="text" icon="mdi-paperclip" size="large" :disabled="!user" :loading="isSelecting"
                    @click="onButtonClick($event), filesMore = false"
                    class="chatservice-input-action-btn chatservice-attachment-btn" />

                  <!-- Hidden file input -->
                  <input ref="uploader" type="file" accept="image/*,audio/mp3,video/mp4,audio/x-m4a,application/*"
                    @change="onFileChanged" id="upload-file" multiple style="display: none;" />

                  <!-- Text input -->
                  <div class="chatservice-text-input-container">
                    <v-textarea ref="RefMessageData" v-model="messageForm.text" placeholder="Type your message..."
                      variant="outlined" rows="1" auto-grow max-rows="6" :disabled="!user"
                      @keydown.enter.shift="Key_Ctrl_Flag = true" @keyup.enter.shift="Shift_Enter_MessageData"
                      @keydown.enter="''"
                      @keyup.enter="(messageForm.text.length > 0 || previews.length > 0) && !statusSendMessage ? (sendMessage($event), Key_Ctrl_Flag = false) : ''"
                      hide-details class="chatservice-chat-input" density="comfortable" />
                  </div>

                  <!-- Action buttons -->
                  <div class="chatservice-input-actions">
                    <!-- Send button -->
                    <v-btn v-if="!statusSendMessage" :disabled="messageForm.text.trim() === '' && previews.length === 0"
                      @click.stop="sendMessage($event)" icon="mdi-send" color="primary" variant="flat" size="large"
                      class="chatservice-send-btn" />

                    <!-- Loading button -->
                    <v-btn v-else icon="mdi-loading mdi-spin" color="primary" variant="flat" size="large" disabled
                      class="chatservice-send-btn chatservice-loading" />
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-text class="flex-grow-1 pt-2" v-else style="height: 100vh; display: flex; justify-content: center; align-items: center;">
              No data available
            </v-card-text>
            <!-- Toggle User List Button -->
            <!-- <v-card-actions>
            </v-card-actions> -->
          </v-card>
        </v-responsive>
      </v-col>
      <!-- </v-slide-x-reverse-transition> -->
    </v-row>

    <!-- Lock Confirmation Dialog -->
    <v-dialog v-model="lockConfirmDialog" max-width="450" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          ยืนยันการรับช่วงต่อ
        </v-card-title>
        <v-card-text>
          <p>ห้องนี้กำลังถูกดูแลโดย <strong>{{ currentLockInfo?.lockedByName }}</strong></p>
          <p class="text-body-2 text-grey mt-2">คุณต้องการรับช่วงต่อจากแอดมินท่านนี้หรือไม่?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="lockConfirmDialog = false">ยกเลิก</v-btn>
          <v-btn v-if="canEdit" color="warning" variant="flat" @click="takeOverLock" :loading="isLocking">
            <v-icon start>mdi-lock-reset</v-icon>
            รับช่วงต่อ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import signalRService from "@/services/signalr-service";
import { useDisplay } from 'vuetify'
// import VueMarkdown from 'vue-markdown-v2'
import MarkdownRenderer from '@/components/MarkedMarkdown.vue'
import facebookImg from "@/assets/brand/facebook-icon.png";
import instagramImg from "@/assets/brand/instagram-icon.png";
import logoLHB from "@/assets/lhb/logoLHB.svg";
import lineImg from "@/assets/brand/line-icon.png";
import fileLinkIcon from '@/assets/images/file-link-svgrepo-com.svg';
import fileAudioIcon from '@/assets/images/file-audio-svgrepo-com.svg';
import fileVideoIcon from '@/assets/images/file-video-svgrepo-com.svg';
import notificationSound from '@/assets/sounds/notification-2-269292.mp3';
import Cookies from 'js-cookie';
export default {
  components: {
    MarkdownRenderer
  },
  inject: ['flagNav', 'tabSocialType', 'NavbarBtnColorTheme', 'colorThemeChat'],
  setup() {
    // ใช้ useDisplay เพื่อเข้าถึง breakpoint
    const display = useDisplay()
    return { display }
  },
  data() {
    return {
      // Debug mode - set to true to enable logging
      debug: import.meta.env.VITE_SIGNALR_DEBUG === 'true' || false,
      anchorAttrs: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      },
      urlApi: import.meta.env.VITE_APP_API,
      date: new Date().toISOString().substr(0, 10),
      today: null,
      showUserList: true,
      user: "",
      username: Cookies.get('username'),
      roleId: Cookies.get('roleId'),
      fullName: Cookies.get('fullName'),
      currentTopicId: 0,
      Log_History_ID: 0,
      Log_History_Take: 5,
      roleId: 0,
      logoBrand: {
        facebook: facebookImg,
        instagram: instagramImg,
        line: lineImg,
        logoLHB: logoLHB,
        // msTeam: require('@/assets/brand/line-icon.png'),
      },
      chatSelected: { topicId: 30, name: "21905fbb-c055-41e2-8ec0-6bb9d2c29ecc", platform: "facebook" },
      selectedItem: 0,
      isMyLockedExpanded: false,
      messages: [],
      messageForm: {
        text: "",
        me: true,
        created_at: new Date().toISOString().substr(0, 10),
      },
      topic: [],
      history: {
        userMsg: [],
        replyMsg: [],
        createDate: []
      },
      scrollMessagesCount: 0,
      connection: null,
      notifications: null,
      selectedColor: '#FFA41E',
      isSelecting: false,
      previews: [],
      loadingMessage: false,
      flagTopHistory: false,
      flagloadingTopic: false,
      StartupLoadingMessage: false,
      loadingUsername: false,
      Key_Ctrl_Flag: false,
      statusSendMessage: false,
      flagGetTopic: false,
      Axios_ControllerTopic: null,
      loadingTopic: false,
      loadingHistory: false,
      search: "",
      SocialType: "",
      menuOpenFull: false,
      menuOpen: false,
      lockFilter: "all", // 'all' | 'myLock' | 'available'
      pingInterval: null,
      fadingOutTopics: [],
      fadingInTopics: [],
      showReloadButton: false,
      // My Locked Topics section
      myLockedTopics: [],
      loadingMyLockedTopic: false,
      flagloadingMyLockedTopic: false,
      fadingOutMyLockedTopics: [],
      fadingInMyLockedTopics: [],
      detachedCurrentTopic: null, // topic ที่ถูกลบจาก list แต่ยังดูอยู่ (กรณี filter=available แล้วโดนล็อค)
      // Closed Topics section (ลูกค้าออกจากแชทแล้ว)
      closedTopics: [],
      loadingClosedTopic: false,
      isClosedExpanded: false,
      fadingOutClosedTopics: [],
      fadingInClosedTopics: [],
      // tabSocialType: [
      //   { text: 'All', value: 'All' ,unreadCount: 0},
      //   { text: 'Facebook', value: 'Facebook' ,unreadCount: 0},
      //   { text: 'Line', value: 'Line' ,unreadCount: 0},
      //   // { text: 'MS Team', value: 'MSTeam' },
      //   // { text: 'Instagram', value: 'Instagram' ,unreadCount: 0},
      // ],
      tab: 'All',
      // Lock/Reservation feature
      isLocking: false, // Loading state for lock action
      lockConfirmDialog: false, // Confirmation dialog for taking over lock
      pendingLockTopicId: null, // Topic ID pending lock confirmation
      // Notification tab title
      originalTitle: 'Chat Service',
      previousUnreadCount: 0,
      // Browser Notification
      browserNotificationEnabled: false,
      // Favicon Badge
      originalFavicon: null,
      faviconCanvas: null,
      faviconCtx: null,
      faviconImg: null,
      // Flashing notification
      flashInterval: null,
      isFlashOn: false,
      flashCount: 0,
    };
  },
  watch: {
    ColorThemeChat(newVal) {
      this.selectedColor = `#${newVal}`;
    },
    "display.width.value": function () {
      this.setResponsive();
    },
    "display.height.value": function () {
      this.setResponsive();
    },
  },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ChatService');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('ChatService'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('ChatService'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('ChatService'));
    },
    sizeTopic() {
      switch (this.display.name.value) {
        case 'xs': return 64
        case 'sm': return 64
        case 'md': return 68
        case 'lg': return 64
        case 'xl': return 72
        case 'xxl': return 80
        default: return 50
      }
    },
    // Dynamic max-height for my locked topics list
    // Each item ~90px (67px min-height + padding/divider/badge), cap at 3 visible items then scroll
    myLockedListMaxHeight() {
      const itemHeight = 90;
      const visibleItems = Math.min(this.myLockedTopics.length, 3);
      return (visibleItems * itemHeight) + 'px';
    },
    reponseWidth() {
      return this.display.width.value >= 1024
    },
    reponseHeigth() {
      return this.display.height.value >= 960
    },
    filteredTopic() {
      // Filtering is now done server-side via API
      // This computed just returns the topic list as-is
      return this.topic;
    },
    // Lock computed properties
    currentTopic() {
      // Search in both topic and myLockedTopics arrays, then detached (removed from list but still viewing)
      return this.topic.find(t => t.topicID === this.currentTopicId) 
          || this.myLockedTopics.find(t => t.topicID === this.currentTopicId) 
          || this.closedTopics.find(t => t.topicID === this.currentTopicId)
          || (this.detachedCurrentTopic && this.detachedCurrentTopic.topicID === this.currentTopicId ? this.detachedCurrentTopic : null)
          || null;
    },
    currentLockInfo() {
      if (!this.currentTopic) return null;
      if (!this.currentTopic.lockedBy) return null;
      return {
        lockedBy: this.currentTopic.lockedBy,
        lockedByName: this.currentTopic.lockedByName
      };
    },
    isCurrentTopicLockedByMe() {
      if (!this.currentTopic || !this.username) return false;
      return this.currentTopic.lockedBy === this.username;
    },
    isCurrentTopicLockedByOther() {
      if (!this.currentTopic) return false;
      return this.currentTopic.lockedBy && this.currentTopic.lockedBy !== this.username;
    },
    isCurrentTopicContactClosed() {
      if (!this.currentTopic) return false;
      return this.currentTopic.statusContactAgent === 'C-Close';
    },
    isCurrentTopicNotLocked() {
      if (!this.currentTopic) return false;
      return !this.currentTopic.lockedBy;
    },
    cannotChat() {
      return !this.isCurrentTopicLockedByMe;
    },
    wealthMembershipColor() {
      if (!this.currentTopic || !this.currentTopic.wealthMembership) return 'grey';
      const membership = this.currentTopic.wealthMembership.toLowerCase();
      const colors = {
        'none': 'grey-lighten-1',
        'starter': 'teal-lighten-1',
        'wealth': 'blue-darken-1',
        'wealth plus': 'indigo-darken-1',
        'elite': 'amber-darken-2',
        'elite plus': 'orange-darken-2',
        'elite privilege': 'deep-purple-darken-1'
      };
      return colors[membership] || 'primary';
    },
    wealthMembershipIcon() {
      if (!this.currentTopic || !this.currentTopic.wealthMembership) return 'mdi-account';
      const membership = this.currentTopic.wealthMembership.toLowerCase();
      const icons = {
        'none': 'mdi-account-outline',
        'starter': 'mdi-star-outline',
        'wealth': 'mdi-star',
        'wealth plus': 'mdi-star-circle',
        'elite': 'mdi-crown',
        'elite plus': 'mdi-crown-outline',
        'elite privilege': 'mdi-diamond-stone'
      };
      return icons[membership] || 'mdi-account';
    },
    lockFilterOptions() {
      return [
        { 
          title: 'All Chats', 
          value: 'all', 
          icon: 'mdi-view-list', 
          color: 'grey' 
        },
        // { 
        //   title: 'จองโดยฉัน', 
        //   value: 'myLock', 
        //   icon: 'mdi-lock-check', 
        //   color: 'success' 
        // },
        { 
          title: 'ห้องว่าง', 
          value: 'available', 
          icon: 'mdi-lock-open-outline', 
          color: 'primary' 
        }
      ];
    },
  },
  beforeDestroy() {
    let self = this
    if (self.pingInterval) {
      clearInterval(self.pingInterval);
    }
    // Unregister SignalR event handlers for this component
    signalRService.offAll('ChatService');
    if (self.debug) console.log("[ChatService] SignalR handlers unregistered");
    // Stop flashing notification
    self.stopFlashing();
    // Remove visibility change listener
    if (self.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', self.handleVisibilityChange);
    }
    // Reset tab title when leaving the page
    document.title = self.originalTitle;
    // Reset favicon when leaving the page
    self.resetFavicon();
  },
  async beforeMount() {
    let self = this
    
    try {
      // Use centralized SignalR service
      self.connection = await signalRService.connect(
        self.username,
        self.roleId?.toString() || '0'
      );
      
      if (self.debug) console.log('[ChatService] SignalR Connected via centralized service');
      
      // Register event handlers with unique handler ID
      signalRService.on("ReceivedMessage", "ChatService", (message, topicId) => {
        if (self.currentTopicId === topicId) {
          let res = {
            "requestTime": self.formatResponseTime(),
            "responseTime": self.formatResponseTime(),
            "id": self.messages.slice(-1)[0].id + 1,
            "messageUser": message,
            "messageImage": null,
            "isRead": null
          }
          self.messages.push(res)
          self.scrollToBottom()
        }
      });

      signalRService.on("BotReply", "ChatService", (message, topicId) => {
        if (self.currentTopicId === topicId) {
          var adminName = '';
          if(message.indexOf('|AdminName|') != -1)
          {
            var splitMessage = message.split('|AdminName|');
            adminName = splitMessage[1];
            message = splitMessage[0];
          }
          let res = {
            "requestTime": self.formatResponseTime(),
            "responseTime": self.formatResponseTime(),
            "id": self.messages.slice(-1)[0].id + 1,
            "messageBot": message,
            "messageImage": null,
            "isRead": null,
            "adminName": adminName
          }
          self.messages.push(res)
          self.scrollToBottom()
        }
      });
      
      signalRService.on("LatestMessageUpdate", "ChatService", (topicId) => {
        self.handleLatestMessageUpdate(topicId);
      });

      // Handle TopicUnread event for updating unread badge counts
      // signalRService.on("TopicUnread", "ChatService", () => {
      //   self.handleTopicUnread();
      // });

      // Handle reconnection events
      signalRService.on("_reconnecting", "ChatService", () => {
        if (self.debug) console.warn("[ChatService] Reconnecting...");
      });

      signalRService.on("_reconnected", "ChatService", async () => {
        try {
          await self.UserSelect(self.currentTopicId, "")
          if (self.debug) console.log("[ChatService] Reconnection Success.")
        }
        catch (error) {
          console.error("[ChatService] Reconnection error:", error)
        }
      });

      // Lock/Unlock SignalR Events
      signalRService.on("TopicLocked", "ChatService", (topicId, lockedBy, lockedByName) => {
        console.log(`[Lock Event] Topic ${topicId} locked by ${lockedByName} (${lockedBy})`);
        
        // Check if locked by me - move to myLockedTopics
        if (lockedBy === self.username) {
          // Find topic in main list
          const topicIndex = self.topic.findIndex(t => t.topicID === topicId);
          if (topicIndex !== -1) {
            const topicToMove = { ...self.topic[topicIndex], lockedBy, lockedByName };
            
            // Fade out animation from main list
            self.fadingOutTopics.push(topicId);
            
            setTimeout(() => {
              // Remove from fadingOut
              const fadeIdx = self.fadingOutTopics.indexOf(topicId);
              if (fadeIdx > -1) self.fadingOutTopics.splice(fadeIdx, 1);
              
              // Remove from main list
              self.topic = self.topic.filter(t => t.topicID !== topicId);
              
              // Add to myLockedTopics with fade in and sort
              self.myLockedTopics.push(topicToMove);
              self.sortMyLockedTopics();
              self.fadingInMyLockedTopics.push(topicId);
              
              setTimeout(() => {
                const fadeInIdx = self.fadingInMyLockedTopics.indexOf(topicId);
                if (fadeInIdx > -1) self.fadingInMyLockedTopics.splice(fadeInIdx, 1);
              }, 500);
              
              // Update selectedItem
              self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
            }, 500);
          } else {
            // Check if in closedTopics
            const closedIndex = self.closedTopics.findIndex(t => t.topicID === topicId);
            if (closedIndex !== -1) {
              const topicToMove = { ...self.closedTopics[closedIndex], lockedBy, lockedByName };
              
              // Fade out from closedTopics
              self.fadingOutClosedTopics.push(topicId);
              setTimeout(() => {
                const fadeIdx = self.fadingOutClosedTopics.indexOf(topicId);
                if (fadeIdx > -1) self.fadingOutClosedTopics.splice(fadeIdx, 1);
                
                self.closedTopics = self.closedTopics.filter(t => t.topicID !== topicId);
                
                // Add to myLockedTopics
                self.myLockedTopics.push(topicToMove);
                self.sortMyLockedTopics();
                self.fadingInMyLockedTopics.push(topicId);
                setTimeout(() => {
                  const fadeInIdx = self.fadingInMyLockedTopics.indexOf(topicId);
                  if (fadeInIdx > -1) self.fadingInMyLockedTopics.splice(fadeInIdx, 1);
                }, 500);
              }, 500);
            } else {
              // Check if already in myLockedTopics
              const myTopic = self.myLockedTopics.find(t => t.topicID === topicId);
              if (myTopic) {
                myTopic.lockedBy = lockedBy;
                myTopic.lockedByName = lockedByName;
              }
            }
          }
        } else {
          // Locked by someone else - check if it was in myLockedTopics (take-over case)
          const myTopicIndex = self.myLockedTopics.findIndex(t => t.topicID === topicId);
          if (myTopicIndex !== -1) {
            // Someone took over my topic!
            const topicData = self.myLockedTopics[myTopicIndex];
            const isContactClosed = topicData.statusContactAgent === 'C-Close';
            const topicToMove = { ...topicData, lockedBy, lockedByName };
            
            // Show notification
            self.$swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'warning',
              title: `${lockedByName} ได้รับช่วงต่อห้องที่คุณดูแลอยู่`,
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true
            });
            
            // Fade out animation from myLockedTopics
            self.fadingOutMyLockedTopics.push(topicId);
            
            setTimeout(() => {
              // Remove from fadingOut
              const fadeIdx = self.fadingOutMyLockedTopics.indexOf(topicId);
              if (fadeIdx > -1) self.fadingOutMyLockedTopics.splice(fadeIdx, 1);
              
              // Remove from myLockedTopics
              self.myLockedTopics = self.myLockedTopics.filter(t => t.topicID !== topicId);
              
              if (isContactClosed) {
                // C-Close topic → move to closedTopics with lock info
                self.closedTopics.push(topicToMove);
                self.sortClosedTopics();
                self.fadingInClosedTopics.push(topicId);
                setTimeout(() => {
                  const fadeInIdx = self.fadingInClosedTopics.indexOf(topicId);
                  if (fadeInIdx > -1) self.fadingInClosedTopics.splice(fadeInIdx, 1);
                }, 500);
              } else if (self.lockFilter !== 'available') {
                // Normal topic → add to main list (only if filter allows)
                self.topic.push(topicToMove);
                self.fadingInTopics.push(topicId);
                
                setTimeout(() => {
                  const fadeInIdx = self.fadingInTopics.indexOf(topicId);
                  if (fadeInIdx > -1) self.fadingInTopics.splice(fadeInIdx, 1);
                }, 500);
              }
            }, 500);
          } else {
            // Topic in main list - check filter
            const topicIndex = self.topic.findIndex(t => t.topicID === topicId);
            if (topicIndex !== -1) {
              if (self.lockFilter === 'available') {
                if (topicId === self.currentTopicId) {
                  // กำลังดู topic นี้อยู่ → อัปเดต lock info ก่อน แล้ว fade out + เก็บไว้ใน detachedCurrentTopic
                  // เพื่อให้ UI แสดง "ห้องนี้กำลังถูกดูแลโดย ..." และหายออกจาก list
                  const topic = self.topic[topicIndex];
                  topic.lockedBy = lockedBy;
                  topic.lockedByName = lockedByName;

                  self.fadingOutTopics.push(topicId);
                  setTimeout(() => {
                    const fadeIdx = self.fadingOutTopics.indexOf(topicId);
                    if (fadeIdx > -1) self.fadingOutTopics.splice(fadeIdx, 1);

                    // Store as detached so currentTopic computed can still find it
                    const topicData = self.topic.find(t => t.topicID === topicId);
                    if (topicData) self.detachedCurrentTopic = { ...topicData };
                    self.topic = self.topic.filter(t => t.topicID !== topicId);
                    self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
                  }, 500);
                } else {
                  // ไม่ใช่ topic ที่กำลังดูอยู่ → fade out และลบออก
                  self.fadingOutTopics.push(topicId);
                  setTimeout(() => {
                    const fadeIdx = self.fadingOutTopics.indexOf(topicId);
                    if (fadeIdx > -1) self.fadingOutTopics.splice(fadeIdx, 1);
                    self.topic = self.topic.filter(t => t.topicID !== topicId);
                    self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
                  }, 500);
                }
              } else {
                // กรณีปกติ (filter = 'all') → อัพเดทข้อมูล lock
                const topic = self.topic[topicIndex];
                topic.lockedBy = lockedBy;
                topic.lockedByName = lockedByName;
              }
            } else {
              // Check in closedTopics - just update lock info (topic stays in closedTopics)
              const closedTopic = self.closedTopics.find(t => t.topicID === topicId);
              if (closedTopic) {
                closedTopic.lockedBy = lockedBy;
                closedTopic.lockedByName = lockedByName;
              }
            }
          }
        }
      });

      signalRService.on("TopicUnlocked", "ChatService", (topicId) => {
        console.log(`[Lock Event] Topic ${topicId} unlocked`);
        
        // Check if in myLockedTopics - move back to appropriate list
        const myTopicIndex = self.myLockedTopics.findIndex(t => t.topicID === topicId);
        if (myTopicIndex !== -1) {
          const topicData = self.myLockedTopics[myTopicIndex];
          const isContactClosed = topicData.statusContactAgent === 'C-Close';
          const topicToMove = { ...topicData, lockedBy: null, lockedByName: null };
          
          // Fade out animation from myLockedTopics
          self.fadingOutMyLockedTopics.push(topicId);
          
          setTimeout(() => {
            // Remove from fadingOut
            const fadeIdx = self.fadingOutMyLockedTopics.indexOf(topicId);
            if (fadeIdx > -1) self.fadingOutMyLockedTopics.splice(fadeIdx, 1);
            
            // Remove from myLockedTopics
            self.myLockedTopics = self.myLockedTopics.filter(t => t.topicID !== topicId);
            
            if (isContactClosed) {
              // C-Close topic → move back to closedTopics
              self.closedTopics.push(topicToMove);
              self.sortClosedTopics();
              self.fadingInClosedTopics.push(topicId);
              
              setTimeout(() => {
                const fadeInIdx = self.fadingInClosedTopics.indexOf(topicId);
                if (fadeInIdx > -1) self.fadingInClosedTopics.splice(fadeInIdx, 1);
              }, 500);
            } else {
              // Normal topic → move back to main list
              self.topic.push(topicToMove);
              self.sortTopics();
              self.fadingInTopics.push(topicId);
              
              // Update selectedItem after sort
              self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
              
              setTimeout(() => {
                const fadeInIdx = self.fadingInTopics.indexOf(topicId);
                if (fadeInIdx > -1) self.fadingInTopics.splice(fadeInIdx, 1);
              }, 500);
            }
          }, 500);
        } else {
          // Clear lock info in main topic list
          const topic = self.topic.find(t => t.topicID === topicId);
          if (topic) {
            topic.lockedBy = null;
            topic.lockedByName = null;
          }
          
          // Clear lock info in closedTopics (topic stays in closedTopics)
          const closedTopic = self.closedTopics.find(t => t.topicID === topicId);
          if (closedTopic) {
            closedTopic.lockedBy = null;
            closedTopic.lockedByName = null;
          }
          
          if (!topic && !closedTopic && self.lockFilter === 'available') {
            // Topic was removed from list when it got locked (filter=available hides locked topics)
            // Now it's unlocked → re-add to list
            if (self.detachedCurrentTopic && self.detachedCurrentTopic.topicID === topicId) {
              // กำลังดู topic นี้อยู่ (detached) → ย้ายกลับเข้า list พร้อม clear detached
              const topicToRestore = { ...self.detachedCurrentTopic, lockedBy: null, lockedByName: null };
              self.detachedCurrentTopic = null;
              self.topic.push(topicToRestore);
              self.sortTopics();
              self.fadingInTopics.push(topicId);
              self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
              setTimeout(() => {
                const fadeInIdx = self.fadingInTopics.indexOf(topicId);
                if (fadeInIdx > -1) self.fadingInTopics.splice(fadeInIdx, 1);
              }, 500);
            } else {
              // Topic อื่นที่ถูกลบออกไป → ดึงข้อมูลกลับมา
              let id = { ID: topicId };
              self.$call.LatestMessage(id, (dataResponse) => {
                if (dataResponse.status === 0 && dataResponse.data) {
                  // Only add if adminReply is true (same check as handleLatestMessageUpdate)
                  if (dataResponse.data.adminReply === true) {
                    const newTopic = {
                      ...dataResponse.data,
                      lockedBy: null,
                      lockedByName: null,
                    };
                    self.topic.push(newTopic);
                    self.sortTopics();
                    self.fadingInTopics.push(topicId);
                    self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
                    setTimeout(() => {
                      const fadeInIdx = self.fadingInTopics.indexOf(topicId);
                      if (fadeInIdx > -1) self.fadingInTopics.splice(fadeInIdx, 1);
                    }, 500);
                  }
                }
              }, (err) => {
                console.error('[TopicUnlocked] Failed to fetch topic:', err);
              });
            }
          }
        }
      });
      
      // Setup ping interval
      self.pingInterval = setInterval(async () => {
        try {
          if (signalRService.connected) {
            await signalRService.invoke("Ping");
          }
        } catch (error) {
          console.log(error);
        }
      }, 30000);
      
    } catch (err) {
      console.error('ChatService: SignalR Connection Error:', err);
    }
  },
  mounted() {
    this.GetDate();
    this.Themecolor();
    // this.TopicUnread();
    this.GetTopicAll("mounted");
    this.GetTopicMyLockAll("mounted");
    this.setResponsive();
    // Save original title for tab title updates
    this.originalTitle = document.title || 'Chat Service';
    // Request browser notification permission
    this.requestNotificationPermission();
    // Initialize favicon badge
    this.initFaviconBadge();
    // Stop flashing when user returns to tab (sound is handled by NavBar)
    this.handleVisibilityChange = () => {
      if (!document.hidden) {
        this.stopFlashing();
      }
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    // NOTE: Notification sound is handled by NavBar (shown on all pages)
    // ChatService only handles visual notifications (favicon, flashing, browser notification)

    // Test method - call from console: run in DevTools after clicking page
    // testSound() {
    //   console.log('[ChatService] Testing sound... (sound is now managed by NavBar)');
    //   const testAudio = new Audio(notificationSound);
    //   testAudio.play()
    //     .then(() => console.log('[ChatService] Sound played successfully!'))
    //     .catch(err => console.log('[ChatService] Sound error:', err.message));
    // },
    updateTabTitle(unreadCount) {
      // Keep original title (no count in parentheses)
      document.title = this.originalTitle;
      // Update favicon badge only
      this.updateFaviconBadge(unreadCount);
    },
    // Favicon Badge Methods
    initFaviconBadge() {
      // Get original favicon
      const linkElement = document.querySelector("link[rel*='icon']");
      if (linkElement) {
        this.originalFavicon = linkElement.href;
      } else {
        this.originalFavicon = '/favicon.ico';
      }

      // Create canvas for drawing badge
      this.faviconCanvas = document.createElement('canvas');
      this.faviconCanvas.width = 32;
      this.faviconCanvas.height = 32;
      this.faviconCtx = this.faviconCanvas.getContext('2d');

      // Load original favicon image
      this.faviconImg = new Image();
      this.faviconImg.crossOrigin = 'anonymous';
      this.faviconImg.src = this.originalFavicon;

      if (this.debug) console.log('[ChatService] Favicon badge initialized');
    },
    updateFaviconBadge(count) {
      if (!this.faviconCanvas || !this.faviconCtx) {
        this.initFaviconBadge();
      }

      const canvas = this.faviconCanvas;
      const ctx = this.faviconCtx;
      const img = this.faviconImg;

      // Wait for image to load
      const drawBadge = () => {
        // Clear canvas
        ctx.clearRect(0, 0, 32, 32);

        // Draw original favicon
        ctx.drawImage(img, 0, 0, 32, 32);

        if (count > 0) {
          // Draw red circle badge - LARGER SIZE
          const badgeRadius = count > 9 ? 14 : 12;
          const badgeX = 32 - badgeRadius;
          const badgeY = badgeRadius;

          // Red circle background
          ctx.beginPath();
          ctx.arc(badgeX, badgeY, badgeRadius, 0, 2 * Math.PI);
          ctx.fillStyle = '#FF0000';
          ctx.fill();

          // White border
          ctx.strokeStyle = '#FFFFFF';
          ctx.lineWidth = 2;
          ctx.stroke();

          // White text - LARGER FONT
          ctx.fillStyle = '#FFFFFF';
          ctx.font = count > 9 ? 'bold 14px Arial' : 'bold 16px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          const displayText = count > 99 ? '99+' : count.toString();
          ctx.fillText(displayText, badgeX, badgeY);
        }

        // Update favicon
        this.setFavicon(canvas.toDataURL('image/png'));
      };

      if (img.complete) {
        drawBadge();
      } else {
        img.onload = drawBadge;
      }
    },
    setFavicon(url) {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = url;
    },
    resetFavicon() {
      if (this.originalFavicon) {
        this.setFavicon(this.originalFavicon);
      }
    },
    // Flashing Notification Methods
    startFlashing(count) {
      // Don't flash if already flashing or count is 0
      if (this.flashInterval || count <= 0) return;

      this.flashCount = count;
      this.isFlashOn = true;

      // Flash every 500ms (2 times per second)
      this.flashInterval = setInterval(() => {
        this.isFlashOn = !this.isFlashOn;

        if (this.isFlashOn) {
          // Show alert state - red badge + alert title
          this.drawFaviconWithColor(this.flashCount, '#FF0000');
          document.title = `🔔 ข้อความใหม่!`;
        } else {
          // Show normal state - orange badge + original title
          this.drawFaviconWithColor(this.flashCount, '#FF6600');
          document.title = this.originalTitle;
        }
      }, 500);

      if (this.debug) console.log('[ChatService] Started flashing notification');
    },
    stopFlashing() {
      if (this.flashInterval) {
        clearInterval(this.flashInterval);
        this.flashInterval = null;
        this.isFlashOn = false;

        // Restore normal state
        if (this.flashCount > 0) {
          this.updateFaviconBadge(this.flashCount);
        } else {
          this.resetFavicon();
        }
        document.title = this.originalTitle;

        if (this.debug) console.log('[ChatService] Stopped flashing notification');
      }
    },
    drawFaviconWithColor(count, color) {
      if (!this.faviconCanvas || !this.faviconCtx || !this.faviconImg) return;

      const ctx = this.faviconCtx;
      const img = this.faviconImg;

      // Clear and draw original
      ctx.clearRect(0, 0, 32, 32);
      ctx.drawImage(img, 0, 0, 32, 32);

      if (count > 0) {
        const badgeRadius = count > 9 ? 14 : 12;
        const badgeX = 32 - badgeRadius;
        const badgeY = badgeRadius;

        // Colored circle background
        ctx.beginPath();
        ctx.arc(badgeX, badgeY, badgeRadius, 0, 2 * Math.PI);
        ctx.fillStyle = color;
        ctx.fill();

        // White border
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 2;
        ctx.stroke();

        // White text
        ctx.fillStyle = '#FFFFFF';
        ctx.font = count > 9 ? 'bold 14px Arial' : 'bold 16px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(count > 99 ? '99+' : count.toString(), badgeX, badgeY);
      }

      this.setFavicon(this.faviconCanvas.toDataURL('image/png'));
    },
    // Browser Notification Methods
    async requestNotificationPermission() {
      console.log('[ChatService] requestNotificationPermission called, current permission:', Notification.permission);

      // Check if browser supports notifications
      if (!('Notification' in window)) {
        console.log('[ChatService] Browser does not support notifications');
        return false;
      }

      // Already granted
      if (Notification.permission === 'granted') {
        this.browserNotificationEnabled = true;
        console.log('[ChatService] Notification permission already granted');
        return true;
      }

      // Request permission if not denied
      if (Notification.permission !== 'denied') {
        try {
          console.log('[ChatService] Requesting notification permission...');
          const permission = await Notification.requestPermission();
          console.log('[ChatService] Permission result:', permission);
          this.browserNotificationEnabled = permission === 'granted';
          return this.browserNotificationEnabled;
        } catch (err) {
          console.log('[ChatService] Notification permission error:', err);
          return false;
        }
      }

      console.log('[ChatService] Notification permission denied');
      return false;
    },
    showBrowserNotification(title, options = {}) {
      // Check if notifications are enabled and permission granted
      if (!this.browserNotificationEnabled || Notification.permission !== 'granted') {
        if (this.debug) console.log('[ChatService] Browser notification blocked: enabled=', this.browserNotificationEnabled, 'permission=', Notification.permission);
        return null;
      }

      // Check sound setting - default to true if not explicitly set to 'false'
      const soundSetting = localStorage.getItem('soundEnabled');
      const notificationEnabled = soundSetting !== 'false'; // true if null, undefined, or 'true'
      if (!notificationEnabled) {
        if (this.debug) console.log('[ChatService] Notification disabled by soundEnabled setting');
        return null;
      }

      try {
        const notification = new Notification(title, {
          body: options.body || '',
          icon: options.icon || '/favicon.ico',
          badge: options.badge || '/favicon.ico',
          tag: options.tag || 'chat-service-notification',
          requireInteraction: options.requireInteraction || false,
          silent: options.silent || false,
          ...options
        });

        // Click handler - focus window and close notification
        notification.onclick = () => {
          window.focus();
          notification.close();
          if (options.onClick && typeof options.onClick === 'function') {
            options.onClick();
          }
        };

        // Auto close after 5 seconds if not requireInteraction
        if (!options.requireInteraction) {
          setTimeout(() => notification.close(), 5000);
        }

        return notification;
      } catch (err) {
        if (this.debug) console.log('[ChatService] Show notification error:', err);
        return null;
      }
    },
    notifyNewMessage(senderName, messageText, topicId) {
      if (this.debug) console.log('[ChatService] notifyNewMessage called:', { senderName, messageText, topicId, documentHidden: document.hidden });

      // Only notify if document is hidden (user on another tab)
      if (!document.hidden) {
        if (this.debug) console.log('[ChatService] Skipping notification - document is visible');
        return;
      }

      const truncatedText = messageText && messageText.length > 50
        ? messageText.substring(0, 50) + '...'
        : messageText || '';

      this.showBrowserNotification('💬 ข้อความใหม่', {
        body: `${senderName || 'ลูกค้า'}: ${truncatedText}`,
        tag: `chat-topic-${topicId}`,
        onClick: () => {
          // Find and select the topic when notification is clicked
          const topic = this.topic.find(t => t.topicID === topicId);
          if (topic) {
            this.OnClickSelectTopicID(topic.topicID, topic.socialType);
          }
        }
      });
    },
    // Test method - call from browser console: app.__vue__.testNotification()
    testNotification() {
      console.log('[ChatService] Testing notification...');
      console.log('[ChatService] browserNotificationEnabled:', this.browserNotificationEnabled);
      console.log('[ChatService] Notification.permission:', Notification.permission);
      console.log('[ChatService] soundEnabled:', localStorage.getItem('soundEnabled'));

      // Force show notification regardless of document.hidden
      const result = this.showBrowserNotification('🔔 Test Notification', {
        body: 'This is a test notification from ChatService',
        tag: 'test-notification'
      });
      console.log('[ChatService] Notification result:', result);
      return result;
    },
    // Lock/Reservation Methods
    isTopicLocked(topicId) {
      const topic = this.topic.find(t => t.topicID === topicId);
      return topic && !!topic.lockedBy;
    },
    isLockedByMe(topicId) {
      const topic = this.topic.find(t => t.topicID === topicId);
      return topic && topic.lockedBy === this.username;
    },
    getLockDisplayName(topicId) {
      const topic = this.topic.find(t => t.topicID === topicId);
      if (!topic || !topic.lockedBy) return '';
      if (topic.lockedBy === this.username) return 'ฉัน';
      return topic.lockedByName || 'แอดมิน';
    },
    // Sort topics: unlocked first (lockedBy null = 0), then locked (1), then by updateDate ascending
    sortTopics() {
      this.topic.sort((a, b) => {
        const aLocked = a.lockedBy ? 1 : 0;
        const bLocked = b.lockedBy ? 1 : 0;
        if (aLocked !== bLocked) return aLocked - bLocked;
        
        const aDate = a.updateDate ? new Date(a.updateDate).getTime() : 0;
        const bDate = b.updateDate ? new Date(b.updateDate).getTime() : 0;
        return aDate - bDate;
      });
    },
    // Sort myLockedTopics by updateDate ascending (all are locked by me)
    sortMyLockedTopics() {
      this.myLockedTopics.sort((a, b) => {
        const aDate = a.updateDate ? new Date(a.updateDate).getTime() : 0;
        const bDate = b.updateDate ? new Date(b.updateDate).getTime() : 0;
        return aDate - bDate;
      });
    },
    // My Locked Topics helper methods
    MyLockedTopicScroll(e) {
      const self = this;
      const element = e.target;
      if (!element) return;
      
      if (Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 1 &&
          !self.loadingMyLockedTopic && self.flagloadingMyLockedTopic) {
        if (self.myLockedTopics.length > 0) {
          self.GetTopicMyLockAll("scroll");
        }
      }
    },
    handleClickMyLocked(topicID, index, socialType) {
      if (this.flagGetTopic != true) {
        this.UserChangeFromMyLocked(topicID, socialType);
      }
    },
    // Closed Topics helper methods
    sortClosedTopics() {
      this.closedTopics.sort((a, b) => {
        const aDate = a.updateDate ? new Date(a.updateDate).getTime() : 0;
        const bDate = b.updateDate ? new Date(b.updateDate).getTime() : 0;
        return aDate - bDate;
      });
    },
    handleClickClosed(topicID, index, socialType) {
      if (this.flagGetTopic != true) {
        this.UserChangeFromClosed(topicID, socialType);
      }
    },
    async UserChangeFromMyLocked(id, socialType) {
      let self = this;
      if (!signalRService.connected) {
        try {
          await signalRService.connect(self.username, self.roleId?.toString() || '0');
        } catch (err) {
          console.error("Disconnect:", err);
          return;
        }
      }
      await self.joinCurrentTopic();
      try {
        await signalRService.invoke("Disconnection", signalRService.connectionId, self.currentTopicId);
      } catch (err) {
        console.error(err);
      }
      await self.UserSelectFromMyLocked(id, socialType);
    },
    async UserSelectFromMyLocked(id, socialType) {
      let self = this;
      if (self.debug) console.log("[ChatService] UserSelectFromMyLocked:", id, socialType);
      self.previews = [];
      self.detachedCurrentTopic = null;
      self.showReloadButton = false;
      self.loadingMessage = true;
      self.StartupLoadingMessage = true;
      self.loadingUsername = true;
      
      var selectedUser = self.myLockedTopics.find((topic) => topic.topicID === id);
      if (!selectedUser) {
        selectedUser = self.topic.find((topic) => topic.topicID === id);
      }
      if (!selectedUser) {
        console.warn("Topic not found:", id);
        self.loadingMessage = false;
        self.loadingUsername = false;
        return;
      }
      
      self.currentTopicId = id;
      self.selectedItem = -1; // Deselect from main list
      self.messages = [];
      let userShowname = (socialType == "Facebook" ? "Facebook" : selectedUser.displayName);
      self.user = userShowname;
      self.loadingUsername = false;

      if (self.Axios_ControllerTopic != null) {
        self.Axios_ControllerTopic.abort();
        self.Axios_ControllerTopic = null;
        await self.UserSelectFromMyLocked(id, socialType);
        return;
      } else {
        self.Axios_ControllerTopic = new AbortController();
      }
      self.flagGetTopic = true;
      let data = {
        TopicID: self.currentTopicId,
        USER_CHANNEL: selectedUser.userChannel,
        ID: 0,
        Take: 5
      };
      let Config = {
        signal: self.Axios_ControllerTopic.signal
      }
      self.$call.GetHistoryMessage(
        data,
        Config,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            self.StartupLoadingMessage = false;
            self.Axios_ControllerTopic = null;
            self.flagGetTopic = false;
            var historyList = dataResponse.data.data;
            if (self.currentTopicId > 0) {
              const myTopic = self.myLockedTopics.find(e => e.topicID == self.currentTopicId);
              if (myTopic && myTopic.unread) {
                self.MarkAsRead(self.currentTopicId);
                myTopic.unread = false;
              }
            }
            if (historyList != null && historyList.length > 0) {
              historyList.forEach(history => {
                self.messages.push(history)
              });
            }
            self.showReloadButton = false;
            self.scrollToBottom()
            self.loadingMessage = false;
            self.flagTopHistory = true;
            self.joinCurrentTopic();
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            })
            self.loadingMessage = false;
          }
        }, (errorResource) => {
          console.error(errorResource);
          self.loadingMessage = false;
        }
      )
    },
    async UserChangeFromClosed(id, socialType) {
      let self = this;
      if (!signalRService.connected) {
        try {
          await signalRService.connect(self.username, self.roleId?.toString() || '0');
        } catch (err) {
          console.error("Disconnect:", err);
          return;
        }
      }
      await self.joinCurrentTopic();
      try {
        await signalRService.invoke("Disconnection", signalRService.connectionId, self.currentTopicId);
      } catch (err) {
        console.error(err);
      }
      await self.UserSelectFromClosed(id, socialType);
    },
    async UserSelectFromClosed(id, socialType) {
      let self = this;
      if (self.debug) console.log("[ChatService] UserSelectFromClosed:", id, socialType);
      self.previews = [];
      self.detachedCurrentTopic = null;
      self.showReloadButton = false;
      self.loadingMessage = true;
      self.StartupLoadingMessage = true;
      self.loadingUsername = true;
      
      var selectedUser = self.closedTopics.find((topic) => topic.topicID === id);
      if (!selectedUser) {
        selectedUser = self.topic.find((topic) => topic.topicID === id);
      }
      if (!selectedUser) {
        console.warn("Topic not found:", id);
        self.loadingMessage = false;
        self.loadingUsername = false;
        return;
      }
      
      self.currentTopicId = id;
      self.selectedItem = -1; // Deselect from main list
      self.messages = [];
      let userShowname = (socialType == "Facebook" ? "Facebook" : selectedUser.displayName);
      self.user = userShowname;
      self.loadingUsername = false;

      if (self.Axios_ControllerTopic != null) {
        self.Axios_ControllerTopic.abort();
        self.Axios_ControllerTopic = null;
        await self.UserSelectFromClosed(id, socialType);
        return;
      } else {
        self.Axios_ControllerTopic = new AbortController();
      }
      self.flagGetTopic = true;
      let data = {
        TopicID: self.currentTopicId,
        USER_CHANNEL: selectedUser.userChannel,
        ID: 0,
        Take: 5
      };
      let Config = {
        signal: self.Axios_ControllerTopic.signal
      }
      self.$call.GetHistoryMessage(
        data,
        Config,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            self.StartupLoadingMessage = false;
            self.Axios_ControllerTopic = null;
            self.flagGetTopic = false;
            var historyList = dataResponse.data.data;
            if (self.currentTopicId > 0) {
              const closedTopic = self.closedTopics.find(e => e.topicID == self.currentTopicId);
              if (closedTopic && closedTopic.unread) {
                self.MarkAsRead(self.currentTopicId);
                closedTopic.unread = false;
              }
            }
            if (historyList != null && historyList.length > 0) {
              historyList.forEach(history => {
                self.messages.push(history)
              });
            }
            self.showReloadButton = false;
            self.scrollToBottom()
            self.loadingMessage = false;
            self.flagTopHistory = true;
            self.joinCurrentTopic();
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            })
            self.loadingMessage = false;
          }
        }, (errorResource) => {
          console.error(errorResource);
          self.loadingMessage = false;
        }
      )
    },
    async releaseLockFromList(topicId) {
      if (!topicId || this.isLocking) return;
      
      this.isLocking = true;
      try {
        await signalRService.invoke('ReleaseLock', topicId, this.username);
        console.log(`Lock released for topic ${topicId}`);
      } catch (error) {
        console.error('Failed to release lock:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถปลดล็อคได้',
          showConfirmButton: false,
          timer: 2000
        });
      } finally {
        this.isLocking = false;
      }
    },
    getWealthColor(membership) {
      if (!membership) return 'grey';
      const colors = {
        'none': 'grey-lighten-1',
        'starter': 'teal-lighten-1',
        'wealth': 'blue-darken-1',
        'wealth plus': 'indigo-darken-1',
        'elite': 'amber-darken-2',
        'elite plus': 'orange-darken-2',
        'elite privilege': 'deep-purple-darken-1'
      };
      return colors[membership.toLowerCase()] || 'primary';
    },
    getWealthIcon(membership) {
      if (!membership) return 'mdi-account';
      const icons = {
        'none': 'mdi-account-outline',
        'starter': 'mdi-star-outline',
        'wealth': 'mdi-star',
        'wealth plus': 'mdi-star-circle',
        'elite': 'mdi-crown',
        'elite plus': 'mdi-crown-outline',
        'elite privilege': 'mdi-diamond-stone'
      };
      return icons[membership.toLowerCase()] || 'mdi-account';
    },
    formatUpdateDate(updateDate) {
      if (!updateDate) return '';
      const date = new Date(updateDate);
      const today = new Date();
      const isToday = date.getDate() === today.getDate() &&
                      date.getMonth() === today.getMonth() &&
                      date.getFullYear() === today.getFullYear();
      
      if (isToday) {
        // Show time only: HH:mm
        return date.toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' });
      } else {
        // Show date only: DD/MM/YYYY
        return date.toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit', year: 'numeric' });
      }
    },
    async acquireLock() {
      if (!this.currentTopicId || this.isLocking) return;
      
      this.isLocking = true;
      try {
        await signalRService.invoke('AcquireLock', this.currentTopicId);
        console.log(`Lock acquired for topic ${this.currentTopicId}`);
      } catch (error) {
        console.error('Failed to acquire lock:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถล็อคห้องได้',
          text: error.message || 'กรุณาลองใหม่อีกครั้ง',
          showConfirmButton: false,
          timer: 2000
        });
      } finally {
        this.isLocking = false;
      }
    },
    async quickAcquireLock(topicId) {
      if (!topicId || this.isLocking) return;
      
      this.isLocking = true;
      try {
        await signalRService.invoke('AcquireLock', topicId);
        console.log(`Quick lock acquired for topic ${topicId}`);
        // Switch to the locked topic
        // this.GetCurrentTopic(topicId);
      } catch (error) {
        console.error('Failed to acquire lock:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถจองห้องได้',
          text: error.message || 'กรุณาลองใหม่อีกครั้ง',
          showConfirmButton: false,
          timer: 2000
        });
      } finally {
        this.isLocking = false;
      }
    },
    async releaseLock() {
      if (!this.currentTopicId || this.isLocking) return;
      
      this.isLocking = true;
      try {
        await signalRService.invoke('ReleaseLock', this.currentTopicId, this.username);
        console.log(`Lock released for topic ${this.currentTopicId}`);
      } catch (error) {
        console.error('Failed to release lock:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถปลดล็อคได้',
          showConfirmButton: false,
          timer: 2000
        });
      } finally {
        this.isLocking = false;
      }
    },
    confirmTakeOverLock() {
      this.pendingLockTopicId = this.currentTopicId;
      this.lockConfirmDialog = true;
    },
    async takeOverLock() {
      if (!this.pendingLockTopicId || this.isLocking) return;
      
      this.isLocking = true;
      try {
        await signalRService.invoke('TakeOverLock', this.pendingLockTopicId);
        console.log(`Lock taken over for topic ${this.pendingLockTopicId}`);
        this.lockConfirmDialog = false;
      } catch (error) {
        console.error('Failed to take over lock:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถรับช่วงต่อได้',
          showConfirmButton: false,
          timer: 2000
        });
      } finally {
        this.isLocking = false;
        this.pendingLockTopicId = null;
      }
    },
    // Handler for LatestMessageUpdate SignalR event
    handleLatestMessageUpdate(topicId) {
      let self = this;

      let id = { ID: topicId }
      self.$call.LatestMessage(id,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            const incomingTopicId = dataResponse.data.topicID;
            const isNowAdminReply = dataResponse.data.adminReply;
            const isStatusClosed = dataResponse.data.statusContactAgent === 'A-Closed';
            const isContactClosed = dataResponse.data.statusContactAgent === 'C-Close';
            
            // ===== ตรวจสอบใน topic array (main list) =====
            const existingTopicIndex = self.topic.findIndex(e => e.topicID == incomingTopicId);
            const existingTopic = existingTopicIndex !== -1 ? self.topic[existingTopicIndex] : null;
            
            // เอา topic ออกจาก list ตอนเคสถูกปิด หรือ ลูกค้าออกจากแชท
            const shouldFadeOutTopic = isStatusClosed || isContactClosed;
            
            if(existingTopicIndex !== -1)
            {
              // ถ้าต้อง fade out ให้เริ่ม animation ก่อน
              if (shouldFadeOutTopic && !self.fadingOutTopics.includes(incomingTopicId)) {
                const topicToMove = isContactClosed ? { ...self.topic[existingTopicIndex], statusContactAgent: 'C-Close' } : null;
                self.fadingOutTopics.push(incomingTopicId);
                
                // หลัง animation เสร็จ (500ms) ให้ลบออกจาก list
                setTimeout(() => {
                  const fadeIndex = self.fadingOutTopics.indexOf(incomingTopicId);
                  if (fadeIndex > -1) {
                    self.fadingOutTopics.splice(fadeIndex, 1);
                  }
                  // ลบ topic ออกจาก list
                  self.topic = self.topic.filter(t => t.topicID !== incomingTopicId);
                  // อัพเดท selectedItem หลังลบ
                  self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
                  
                  // ถ้าเป็น C-Close ให้ย้ายไป closedTopics
                  if (isContactClosed && topicToMove) {
                    self.closedTopics.push(topicToMove);
                    self.sortClosedTopics();
                    self.fadingInClosedTopics.push(incomingTopicId);
                    setTimeout(() => {
                      const fadeInIdx = self.fadingInClosedTopics.indexOf(incomingTopicId);
                      if (fadeInIdx > -1) self.fadingInClosedTopics.splice(fadeInIdx, 1);
                    }, 500);
                  }
                  
                  // ถ้า topic ที่ถูกลบคือ topic ที่กำลังเลือกอยู่ ให้เคลียร์ chat (เฉพาะ A-Closed)
                  if (isStatusClosed && self.currentTopicId == incomingTopicId)
                  {
                    self.messages = [];
                    self.user = "";
                  }
                  
                  // ถ้า topic ที่ถูกลบคือ topic ที่กำลังเลือกอยู่ ให้เลือก topic แรก (เฉพาะ A-Closed)
                  if (isStatusClosed && self.currentTopicId == incomingTopicId && self.topic.length > 0) {
                    self.UserSelect(self.topic[0].topicID, self.topic[0].socialType);
                  }
                }, 500);
              } else {
                // กรณีปกติ อัพเดทข้อมูล topic
                self.topic = self.topic.map(currentTopic =>
                  currentTopic.topicID == incomingTopicId ?
                    {
                      ...currentTopic,
                      latestMsg: dataResponse.data.latestMsg,
                      updateDate: dataResponse.data.updateDate,
                      adminReply: dataResponse.data.adminReply,
                      unread: self.currentTopicId == incomingTopicId ? false : dataResponse.data.unread,
                      statusContactAgent: dataResponse.data.statusContactAgent,
                      displayName: dataResponse.data.displayName ?? currentTopic.displayName
                    }
                    : currentTopic
                );

                // Browser Notification: แจ้งเตือนเมื่อมีข้อความใหม่จากลูกค้า
                // (ไม่ใช่ข้อความจาก admin และไม่ใช่ topic ที่กำลังดูอยู่)
                if (!isNowAdminReply && self.currentTopicId != incomingTopicId) {
                  const senderName = existingTopic?.displayName ||
                                    existingTopic?.cifNo
                                    'ลูกค้า';
                  self.notifyNewMessage(senderName, dataResponse.data.latestMsg, incomingTopicId);
                }
              }
              
              // ถ้าไม่ได้ fade out ก็อัพเดท selectedItem ตามปกติ
              if (!shouldFadeOutTopic) {
                self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
              }
            }
            
            // ===== ตรวจสอบใน myLockedTopics array =====
            const myLockedTopicIndex = self.myLockedTopics.findIndex(e => e.topicID == incomingTopicId);
            const myLockedTopic = myLockedTopicIndex !== -1 ? self.myLockedTopics[myLockedTopicIndex] : null;
            
            // เอา topic ออกจาก myLockedTopics เฉพาะตอนเคสถูกปิดเท่านั้น
            const shouldFadeOutMyLocked = isStatusClosed;
            
            if (myLockedTopicIndex !== -1) {
              // ถ้าต้อง fade out ให้เริ่ม animation ก่อน
              if (shouldFadeOutMyLocked && !self.fadingOutMyLockedTopics.includes(incomingTopicId)) {
                self.fadingOutMyLockedTopics.push(incomingTopicId);
                
                // หลัง animation เสร็จ (500ms) ให้ลบออกจาก list
                setTimeout(() => {
                  const fadeIndex = self.fadingOutMyLockedTopics.indexOf(incomingTopicId);
                  if (fadeIndex > -1) {
                    self.fadingOutMyLockedTopics.splice(fadeIndex, 1);
                  }
                  // ลบ topic ออกจาก myLockedTopics
                  self.myLockedTopics = self.myLockedTopics.filter(t => t.topicID !== incomingTopicId);
                  
                  // ถ้า topic ที่ถูกลบคือ topic ที่กำลังเลือกอยู่ ให้เคลียร์ chat และเลือก topic ถัดไป
                  if (self.currentTopicId == incomingTopicId) {
                    self.messages = [];
                    self.user = "";
                    
                    // เลือก topic แรกจาก myLockedTopics หรือ topic
                    if (self.myLockedTopics.length > 0) {
                      self.UserSelectFromMyLocked(self.myLockedTopics[0].topicID, self.myLockedTopics[0].socialType);
                    } else if (self.topic.length > 0) {
                      self.UserSelect(self.topic[0].topicID, self.topic[0].socialType);
                    }
                  }
                }, 500);
              } else {
                // กรณีปกติ อัพเดทข้อมูล myLockedTopic (latestMsg, updateDate, unread)
                self.myLockedTopics = self.myLockedTopics.map(currentTopic =>
                  currentTopic.topicID == incomingTopicId ?
                    {
                      ...currentTopic,
                      latestMsg: dataResponse.data.latestMsg,
                      updateDate: dataResponse.data.updateDate,
                      adminReply: dataResponse.data.adminReply,
                      unread: self.currentTopicId == incomingTopicId ? false : dataResponse.data.unread,
                      statusContactAgent: dataResponse.data.statusContactAgent,
                      displayName: dataResponse.data.displayName ?? currentTopic.displayName
                    }
                    : currentTopic
                );
              }
            }
            
            // ===== ตรวจสอบใน closedTopics array =====
            const closedTopicIndex = self.closedTopics.findIndex(e => e.topicID == incomingTopicId);
            
            if (closedTopicIndex !== -1) {
              if (isStatusClosed) {
                // A-Closed: ลบออกจาก closedTopics
                self.fadingOutClosedTopics.push(incomingTopicId);
                setTimeout(() => {
                  const fadeIndex = self.fadingOutClosedTopics.indexOf(incomingTopicId);
                  if (fadeIndex > -1) self.fadingOutClosedTopics.splice(fadeIndex, 1);
                  self.closedTopics = self.closedTopics.filter(t => t.topicID !== incomingTopicId);
                  if (self.currentTopicId == incomingTopicId) {
                    self.messages = [];
                    self.user = "";
                    if (self.topic.length > 0) {
                      self.UserSelect(self.topic[0].topicID, self.topic[0].socialType);
                    }
                  }
                }, 500);
              } else if (!isContactClosed) {
                // ลูกค้ากลับมาแล้ว (C-Active): ย้ายจาก closedTopics กลับไป main list
                const topicToMove = { ...self.closedTopics[closedTopicIndex], ...dataResponse.data };
                self.fadingOutClosedTopics.push(incomingTopicId);
                setTimeout(() => {
                  const fadeIndex = self.fadingOutClosedTopics.indexOf(incomingTopicId);
                  if (fadeIndex > -1) self.fadingOutClosedTopics.splice(fadeIndex, 1);
                  self.closedTopics = self.closedTopics.filter(t => t.topicID !== incomingTopicId);
                  
                  // เพิ่มกลับไป main list ถ้า adminReply
                  if (topicToMove.adminReply === true) {
                    self.topic.push(topicToMove);
                    self.sortTopics && self.sortTopics();
                    self.fadingInTopics.push(incomingTopicId);
                    self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
                    setTimeout(() => {
                      const fadeInIdx = self.fadingInTopics.indexOf(incomingTopicId);
                      if (fadeInIdx > -1) self.fadingInTopics.splice(fadeInIdx, 1);
                    }, 500);
                  }
                }, 500);
              } else {
                // ยังเป็น C-Close อยู่: อัพเดทข้อมูล
                self.closedTopics = self.closedTopics.map(currentTopic =>
                  currentTopic.topicID == incomingTopicId ?
                    {
                      ...currentTopic,
                      latestMsg: dataResponse.data.latestMsg,
                      updateDate: dataResponse.data.updateDate,
                      adminReply: dataResponse.data.adminReply,
                      unread: self.currentTopicId == incomingTopicId ? false : dataResponse.data.unread,
                      statusContactAgent: dataResponse.data.statusContactAgent,
                      displayName: dataResponse.data.displayName ?? currentTopic.displayName
                    }
                    : currentTopic
                );
              }
            }
            
            // ===== topic ใหม่ที่ไม่อยู่ในทั้งสาม array =====
            if (existingTopicIndex === -1 && myLockedTopicIndex === -1 && closedTopicIndex === -1) {
              if (isContactClosed) {
                // topic ใหม่ที่เป็น C-Close → เพิ่มเข้า closedTopics
                const newTopicId = dataResponse.data.topicID;
                self.closedTopics.push(dataResponse.data);
                self.sortClosedTopics();
                self.fadingInClosedTopics.push(newTopicId);
                setTimeout(() => {
                  const fadeInIndex = self.fadingInClosedTopics.indexOf(newTopicId);
                  if (fadeInIndex > -1) self.fadingInClosedTopics.splice(fadeInIndex, 1);
                }, 500);
              } else if (dataResponse.data.adminReply === true) {
                // topic ใหม่ เพิ่มเข้า list เฉพาะถ้าเป็น Admin reply
                const newTopicId = dataResponse.data.topicID;
                
                // เพิ่ม topic ที่ index แรก (ของใหม่) และ trigger fade-in animation
                self.topic.push(dataResponse.data);
                self.fadingInTopics.push(newTopicId);
                
                // อัพเดท selectedItem เพื่อ highlight topic ที่กำลังดูอยู่
                self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
                
                // ลบ fade-in class หลัง animation เสร็จ (500ms)
                setTimeout(() => {
                  const fadeInIndex = self.fadingInTopics.indexOf(newTopicId);
                  if (fadeInIndex > -1) {
                    self.fadingInTopics.splice(fadeInIndex, 1);
                  }
                }, 500);
              }
            }
            
            if (self.currentTopicId == incomingTopicId) {
              self.MarkAsRead(incomingTopicId);
            }
          }
        },
        (errorResource) => {
          console.error("Error: ", errorResource)
        });
    },
    onLockFilterChange() {
      this.GetTopicAll("search");
    },
    Search() {
      let self = this;
      self.GetTopicAll("search");
      self.menuOpenFull = false;
      self.menuOpen = false;
    },
    onTabChange(newTab) {
      let self = this;
      self.SocialType = self.tabSocialType[newTab].value;
      self.GetTopicAll("changeTab");
    },
    setResponsive() {
      const root = document.documentElement;
      let width = this.display.width.value;
      let height = this.display.height.value;
      let isHeight = this.reponseHeigth ? (height - 140) - 56 : height - 140;
      root.style.setProperty('--responsiveSizeW', width + 'px');
      root.style.setProperty('--responsiveSizeH', isHeight + 'px');
    },
    onButtonClick() {
      this.isSelecting = true
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, { once: true })

      this.$refs.uploader.click()
    },
    onFileChanged(item) {
      let self = this;
      let files = item.target.files;
      if (!files || files.length === 0) {
        return; // หยุดฟังฝ์ชันถ้าไม่มีไฟล์ที่เลือก (ฝดยฝเลิฝ)
      }
      if (!self.filesMore) {
        self.previews = [];
      }
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        let fileType = "";
        if (file.type.startsWith("image/")) {
          fileType = "image";
        } else if (file.type.startsWith("audio/")) {
          fileType = "audio";
        } else if (file.type.startsWith("video/")) {
          fileType = "video";
        }
        reader.onload = (e) => {
          switch (fileType) {
            case "image": {
              self.previews.push({ src: e.target.result, file, filename: file.name });
              break;
            }
            case "audio": {
              self.previews.push({ src: fileAudioIcon, file, filename: file.name });
              break;
            }
            case "video": {
              self.previews.push({ src: fileVideoIcon, file, filename: file.name });
              break;
            }
            default: {
      self.previews.push({ src: fileLinkIcon, file, filename: file.name });
              break;
            }
          }

        };
        reader.readAsDataURL(file);
      }
      this.$refs.uploader.value = "";
    },
    removeFile(index) {
      if (this.previews.length == 1) {
        this.previews = [];
        this.$refs.uploader.value = "";
      } else {
        this.previews.splice(index, 1);
      }
    },
    async joinCurrentTopic()
    {
      let self = this;
      
      // รอให้ SignalR เชื่อมต่อก่อนถ้ายังไม่เชื่อมต่อ (กรณีโหลดหน้าครั้งแรก)
      if(!signalRService.connected)
      {
        try {
          if (self.debug) console.log("[ChatService] Waiting for SignalR connection...");
          
          // เพิ่ม timeout protection (30 วินาที)
          const connectPromise = signalRService.connect(self.username, self.roleId?.toString() || '0');
          const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => reject(new Error('Connection timeout after 30 seconds')), 30000);
          });
          
          await Promise.race([connectPromise, timeoutPromise]);
          if (self.debug) console.log("[ChatService] SignalR connected successfully");
        } catch (err) {
          console.error("[ChatService] Failed to connect SignalR:", err);
          return;
        }
      }
      
      try {
        await signalRService.invoke("JoinChat", self.currentTopicId, signalRService.connectionId);
        if (self.debug) console.log("[ChatService] JoinChat success:", self.currentTopicId);
      } catch (err) {
        console.error("[ChatService] JoinChat failed:", err);
      }
    },
    async handleClick(topicID, index, socialType) {
      if (this.flagGetTopic != true) {
        await this.UserChange(topicID, socialType);
        this.selectedItem = index;
      }
      this.switchClicked = false;
    },
    async handleSwitchChange(topicID, currentStatus) {
      let self = this;
      
      // ป้องกันการเรียก API ซ้ำ - ค้นหาจากทั้ง topic, myLockedTopics และ closedTopics
      let tempTopic = self.topic.find(topic => topic.topicID === topicID);
      let isFromMyLocked = false;
      let isFromClosed = false;
      if (!tempTopic) {
        tempTopic = self.myLockedTopics.find(topic => topic.topicID === topicID);
        isFromMyLocked = true;
      }
      if (!tempTopic) {
        tempTopic = self.closedTopics.find(topic => topic.topicID === topicID);
        isFromMyLocked = false;
        isFromClosed = true;
      }
      if (!tempTopic) {
        console.warn(`Topic ${topicID} not found in all lists`);
        return;
      }
      
      // สถานะใหม่ที่ต้องการเปลี่ยนเป็น (toggle)
      // const newStatus = !currentStatus;
      const newStatus = false;
      
      console.log(`Switching topic ${topicID} from ${currentStatus} to ${newStatus} (isFromMyLocked: ${isFromMyLocked})`);
      
      // ถ้าเปลี่ยนเป็น Bot (false) ให้ทำ fade out animation
      if (newStatus === false) {
        // เริ่ม fade animation ทันที (ใช้ array ที่ถูกต้องตามที่ topic อยู่)
        const fadingArray = isFromClosed ? self.fadingOutClosedTopics : (isFromMyLocked ? self.fadingOutMyLockedTopics : self.fadingOutTopics);
        if (!fadingArray.includes(topicID)) {
          fadingArray.push(topicID);
        }
        
        // เรียก API
        self.$call.AdminReplyStatus(
          topicID, newStatus, this.connection.connectionId, (dataResponse) => {
            if (dataResponse.status === 0) {
              console.log(`API Success: topic ${topicID} changed to ${newStatus}`);
              
              // หลัง animation เสร็จ (500ms) ให้ลบออกจาก list
              setTimeout(() => {
                const fadeIndex = fadingArray.indexOf(topicID);
                if (fadeIndex > -1) {
                  fadingArray.splice(fadeIndex, 1);
                }
                // ลบ topic ออกจาก list ที่ถูกต้อง
                if (isFromClosed) {
                  self.closedTopics = self.closedTopics.filter(t => t.topicID !== topicID);
                } else if (isFromMyLocked) {
                  self.myLockedTopics = self.myLockedTopics.filter(t => t.topicID !== topicID);
                } else {
                  self.topic = self.topic.filter(t => t.topicID !== topicID);
                  // อัพเดท selectedItem หลังลบ
                  self.selectedItem = self.topic.findIndex(e => e.topicID == self.currentTopicId);
                }

                // ถ้า topic ที่ถูกลบคือ topic ที่กำลังเลือกอยู่ ให้เคลียร์ chat
                if (self.currentTopicId == topicID)
                {
                  self.messages = [];
                  self.user = "";
                }
                
                // ถ้า topic ที่ถูกลบคือ topic ที่กำลังเลือกอยู่ ให้เลือก topic แรก
                if (self.currentTopicId == topicID && self.topic.length > 0) {
                  self.UserSelect(self.topic[0].topicID, self.topic[0].socialType);
                }
              }, 500);
            }
            else {
              // ถ้า API fail ให้ revert กลับและหยุด fade
              const fadeIndex = fadingArray.indexOf(topicID);
              if (fadeIndex > -1) {
                fadingArray.splice(fadeIndex, 1);
              }
              tempTopic.adminReply = currentStatus;
              console.error(`API Failed: reverting topic ${topicID} to ${currentStatus}`);
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2000,
              })
            }
          }, (errorResource) => {
            // ถ้า error ให้ revert กลับและหยุด fade
            const fadeIndex = fadingArray.indexOf(topicID);
            if (fadeIndex > -1) {
              fadingArray.splice(fadeIndex, 1);
            }
            tempTopic.adminReply = currentStatus;
            console.error(`API Error: reverting topic ${topicID} to ${currentStatus}`, errorResource);
          }
        )
      } else {
        // เปลี่ยนเป็น Admin (true) - ทำงานปกติไม่ต้อง fade
        tempTopic.adminReply = newStatus;
        
        // เรียก API
        self.$call.AdminReplyStatus(
          topicID, newStatus, this.connection.connectionId, (dataResponse) => {
            if (dataResponse.status === 0) {
              console.log(`API Success: topic ${topicID} changed to ${newStatus}`);
            }
            else {
              // ถ้า API fail ให้ revert กลับ
              tempTopic.adminReply = currentStatus;
              console.error(`API Failed: reverting topic ${topicID} to ${currentStatus}`);
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2000,
              })
            }
          }, (errorResource) => {
            // ถ้า error ให้ revert กลับ
            tempTopic.adminReply = currentStatus;
            console.error(`API Error: reverting topic ${topicID} to ${currentStatus}`, errorResource);
          }
        )
      }
    },

    Themecolor() {
      this.selectedColor = this.colorThemeChat != null ? `#${this.colorThemeChat}` : '#FFA41E';
    },

    Shift_Enter_MessageData() {
      let self = this;
      let text = self.messageForm.text;

      const inputElement = self.$refs.RefMessageData?.$refs?.input;
      if (inputElement && typeof inputElement.selectionStart !== 'undefined') {
        let _point = (inputElement.selectionStart - 1);
        self.$nextTick(() => {
          if (inputElement && typeof inputElement.selectionStart !== 'undefined') {
            inputElement.selectionStart = _point + 2;
            inputElement.selectionEnd = _point + 2;
            if (inputElement.selectionStart >= text.length) {
              const height = inputElement.scrollHeight;
              inputElement.scrollTop = height;
            }
          }
        });
      }
    },
    sendMessage(e) {
      let self = this;
      let text = self.messageForm.text;
      let Files = []
      const formData = new FormData();
      if (!signalRService.connected) {
        signalRService.connect(self.username, self.roleId?.toString() || '0').then(() => {
          console.warn("Reconnecting...");
          self.sendMessage(e)
          return;
        });
      }
      if (text.trim() == "" && self.previews.length == 0) {
        return;
      }
      if (e.key == 'Enter') {
        if (self.Key_Ctrl_Flag == true) {
          return;
        }
        const inputElement = self.$refs.RefMessageData?.$refs?.input;
        if (inputElement && typeof inputElement.selectionStart !== 'undefined') {
          let _point = (inputElement.selectionStart - 1);
          if (text.length > 0 && text[_point] == "\n") {
            text = text.slice(0, _point) + text.slice(_point + 1);
          }
        }
      }

      self.statusSendMessage = true;
      self.messageForm.text = "";
      if (self.previews.length > 0) {
        let Axios_Controller = new AbortController();
        let Config = {
          signal: Axios_Controller.signal
        }
        self.previews.forEach((e) => {
          Files.push(e.file) // เฝ็บไฟล์
          formData.append(`files`, e.file); // Append each file to formData
        });
        let temp = {
          files: formData,
          // req: {
          type: "Line",
          topic: self.currentTopicId,
          // }
        }
        // let file = Files;
        self.$call.SendFileMessage(temp, Config,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let temp = dataResponse.data;
              self.previews = [];
              temp.forEach((e) => {
                let tempObj = {
                  text: e.text,
                  groupID: e.groupID,
                  fileID: e.fileID,
                }
                let tempText = JSON.stringify(tempObj);
                signalRService.invoke('SendMessage', `${tempText}`, self.currentTopicId, signalRService.connectionId, e.type).then(() => {
                  let type = e.type == 'Image' ? `![${e.type}](${e.text})` : e.text;
                  let res = {
                    messageBot: `${type}`,
                    messageImage: null,
                    messageUser: null,
                    requestTime: self.formatResponseTime(),
                    responseTime: self.formatResponseTime(),
                    isRead: true
                  }
                  self.messageForm.text = "";
                  self.messages.push(res)
                  // Only update selectedItem if current topic is NOT from myLockedTopics
                  const isFromMyLocked = self.myLockedTopics.some(t => t.topicID === self.currentTopicId);
                  if (!isFromMyLocked) {
                    self.selectedItem = self.topic.findIndex(t => t.topicID === self.currentTopicId);
                  }
                  self.scrollToBottom()
                });
              });

              if (text != "" && text != null && text != undefined) {
                signalRService.invoke('SendMessage', text, self.currentTopicId, signalRService.connectionId, "Text").then(() => {
                  let res = {
                    messageBot: text,
                    messageImage: null,
                    messageUser: null,
                    requestTime: self.formatResponseTime(),
                    responseTime: self.formatResponseTime(),
                    isRead: true
                  }
                  self.messageForm.text = "";
                  self.previews = [];
                  self.messages.push(res)
                  // Only update selectedItem if current topic is NOT from myLockedTopics
                  const isFromMyLocked = self.myLockedTopics.some(t => t.topicID === self.currentTopicId);
                  if (!isFromMyLocked) {
                    self.selectedItem = self.topic.findIndex(t => t.topicID === self.currentTopicId);
                  }
                  self.scrollToBottom()
                });
              }
            }
            self.statusSendMessage = false;
            // self.dialog = false;
          },
          (ex) => {
            self.$swal.fire({
              icon: 'alert',
              title: ex,
              showConfirmButton: false,
              timer: 1500,
            });
            self.statusSendMessage = false;
          }
        )
      } else {
        signalRService.invoke('SendMessage', text, self.currentTopicId, signalRService.connectionId, "Text").then(() => {
          let res = {
            messageBot: text,
            messageImage: null,
            messageUser: null,
            requestTime: self.formatResponseTime(),
            responseTime: self.formatResponseTime(),
            isRead: true
          }
          self.messageForm.text = "";
          self.previews = [];
          self.messages.push(res)
          self.statusSendMessage = false;
          // Only update selectedItem if current topic is NOT from myLockedTopics
          const isFromMyLocked = self.myLockedTopics.some(t => t.topicID === self.currentTopicId);
          if (!isFromMyLocked) {
            self.selectedItem = self.topic.findIndex(t => t.topicID === self.currentTopicId);
          }
          self.scrollToBottom()
        });
      }
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    toggleUserList() {
      this.showUserList = !this.showUserList;
    },
    scrollToBottom() {
      // เพิ่ม delay มากขึ้นและใช้ force scroll
      setTimeout(() => {
        const element = this.$refs.scrollContainer
        
        if (!element) {
          console.warn('scrollContainer ref not found')
          return
        }

        // ลอง scroll element หลัก
        const scrollElement = element.$el || element
        
        if (scrollElement) {
          // Force scroll to bottom
          scrollElement.scrollTop = scrollElement.scrollHeight + 1000
          
          // Verify scroll after a short delay
          setTimeout(() => {
            if (scrollElement) {
              scrollElement.scrollTop = scrollElement.scrollHeight + 1000
              // console.log('Scrolled to:', scrollElement.scrollTop, 'Height:', scrollElement.scrollHeight)
            }
          }, 100)
        }
      }, 200)
    },
    // keepSelection = true ⇒ ห้ามเด้งไปห้องแรกของ list ทับห้องที่ผู้ใช้เปิดค้างไว้ (ดู reloadMessages)
    GetTopicAll(status, keepSelection = false) {
      let self = this
      if (self.loadingTopic == true) {
        return;
      }
      if (status != "scroll") {
        self.loadingTopic = true;
        self.flagloadingTopic = true;
      }
      // const TopicID =  self.TopicId;
      // const TopicID = self.Log
      // const Take = self.Log_History_Take;
      let adminReply = null;

      if (this.contactStatus === "agent") {
        adminReply = true;
      } else if (this.contactStatus === "bot") {
        adminReply = false;
      }
      const search = self.search;
      const SocialType = self.SocialType == 0 ? 'All' : self.SocialType;
      // Use Skip for pagination instead of UpdateDate
      const skip = status == "changeTab" || status == "search" || status == "mounted" ? 0 : self.topic.length;
      let take = (() => {
        switch (this.display.name.value) {
          case 'xs': return 10
          case 'sm': return 10
          case 'md': return 10
          case 'lg': return 10
          case 'xl': return 20
          case 'xxl': return 35
          default: return 45
        }
      })();
      let data = {
        // TopicID: TopicID,
        // USER_CHANNEL: self.$root.User_Id,
        // ID: Log_History_ID,
        Take: take,
        Skip: skip,
        Search: search,
        socialType: SocialType,
        filter: {
          name: search,
          adminReply: adminReply,
          lockFilter: self.lockFilter, // 'all' | 'myLock' | 'available'
        }
      };

      self.$call.GetTopicAll(
        data,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            var allTopics = dataResponse.data;
            // Split C-Close topics into closedTopics array
            var topicList = allTopics.filter(t => t.statusContactAgent !== 'C-Close');
            var closedList = allTopics.filter(t => t.statusContactAgent === 'C-Close');

            if (topicList.length == 0 && closedList.length == 0) {
              self.flagloadingTopic = false;
              console.warn("No data found");
            }
            if (status == "scroll") {
              // #480: BAL ไม่แบ่งหน้าแล้ว (คืน list ทั้งหมดทุกครั้ง) — ต่อท้ายเฉพาะแถวที่ยังไม่มี กันแถวซ้ำ
              // และถ้าไม่มีของใหม่เลยให้หยุด TopicScroll ไม่ให้ยิงซ้ำทุกครั้งที่เลื่อนถึงก้น list
              const knownIds = new Set([...self.topic, ...self.closedTopics].map(t => t.topicID));
              const newTopics = topicList.filter(t => !knownIds.has(t.topicID));
              const newClosed = closedList.filter(t => !knownIds.has(t.topicID));
              if (newTopics.length == 0 && newClosed.length == 0) {
                self.flagloadingTopic = false;
              }
              self.topic = self.topic.concat(newTopics);
              self.closedTopics = self.closedTopics.concat(newClosed);
            } else if (status == "search" || status == "mounted" || status == "changeTab") {
              self.topic = topicList;
              self.closedTopics = closedList;
              if (self.topic.length == 0 && self.closedTopics.length == 0) {
                if (!keepSelection) {
                  self.messages = [];
                  self.user = "";
                }
              }else if (self.topic.length > 0 && !keepSelection) {
                self.UserSelect(self.topic[0].topicID, self.topic[0].socialType)
              } 
            }
            self.loadingTopic = false;
          }

        }, (errorResource) => {
          console.error(errorResource);
          self.loadingTopic = false;
        }
      )
    },
    GetTopicMyLockAll(status) {
      let self = this;
      if (self.loadingMyLockedTopic == true) return;
      
      self.loadingMyLockedTopic = true;
      
      let adminReply = null;
      if (this.contactStatus === "agent") {
        adminReply = true;
      } else if (this.contactStatus === "bot") {
        adminReply = false;
      }
      
      const search = self.search;
      const SocialType = self.SocialType == 0 ? 'All' : self.SocialType;
      
      // No pagination needed - fetch all user's locked topics
      let data = {
        Search: search,
        socialType: SocialType,
        filter: {
          name: search,
          adminReply: adminReply,
        }
      };

      self.$call.GetTopicMyLockAll(data, (dataResponse) => {
        if (dataResponse.status === 0) {
          var topicList = dataResponse.data;
          self.myLockedTopics = topicList;
          // If we have myLockedTopics and no topic selected yet, select first one
          if (self.myLockedTopics.length > 0 && !self.currentTopicId && self.topic.length === 0) {
            self.UserSelectFromMyLocked(self.myLockedTopics[0].topicID, self.myLockedTopics[0].socialType);
          }
        }
        self.loadingMyLockedTopic = false;
      }, (errorResource) => {
        console.error(errorResource);
        self.loadingMyLockedTopic = false;
      });
    },
    GetTopicClosedAll() {
      let self = this;
      if (self.loadingClosedTopic == true) return;
      
      self.loadingClosedTopic = true;
      
      const search = self.search;
      const SocialType = self.SocialType == 0 ? 'All' : self.SocialType;
      
      let data = {
        Search: search,
        socialType: SocialType,
        filter: {
          name: search,
        }
      };

      self.$call.GetTopicClosedAll(data, (dataResponse) => {
        if (dataResponse.status === 0) {
          self.closedTopics = dataResponse.data;
        }
        self.loadingClosedTopic = false;
      }, (errorResource) => {
        console.error(errorResource);
        self.loadingClosedTopic = false;
      });
    },
    GetRoleId() {
      let self = this
      self.$call.GetRoleId(
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.roleId = dataResponse.data
          }

        }, (errorResource) => {
          console.error(errorResource);
        }
      )
    },
    // แถวของห้องหนึ่ง ไม่ว่ามันจะอยู่ list ไหน — ลำดับเดียวกับ computed currentTopic
    // 🔴 ห้องที่กำลังเปิดอยู่ไม่ได้อยู่ใน self.topic เสมอไป: list หลักแบ่งหน้า (Skip/Take ตามขนาดจอ)
    //    และกันห้องที่เราจองเองออกไปอยู่แล้ว ⇒ การอ่านจาก self.topic ที่เดียวคือที่มาของ "แชทหาย"
    findTopicRow(id) {
      return this.topic.find(t => t.topicID === id)
          || this.myLockedTopics.find(t => t.topicID === id)
          || this.closedTopics.find(t => t.topicID === id)
          || (this.detachedCurrentTopic && this.detachedCurrentTopic.topicID === id ? this.detachedCurrentTopic : null)
          || null;
    },
    async UserSelect(id, socialType) {
      let self = this;
      if (self.debug) console.log("[ChatService] UserSelect:", id, socialType);
      self.previews = [];
      self.showReloadButton = false;
      const connectionId = signalRService.connectionId;
      self.loadingMessage = true;
      self.StartupLoadingMessage = true;
      self.loadingUsername = true;
      var selectedUser = self.findTopicRow(id);
      // ไม่เจอจริง ๆ = หยุดแบบเงียบและคืนสถานะ loading ให้ครบ
      // เดิมอ่าน selectedUser.displayName ต่อทันที → TypeError ตายกลางเมธอด จอค้างที่ spinner
      if (!selectedUser) {
        console.warn("[ChatService] Topic not found:", id);
        self.loadingMessage = false;
        self.StartupLoadingMessage = false;
        self.loadingUsername = false;
        return;
      }
      // อยู่ใน list หลัก = ไม่ต้อง detach · ไม่อยู่ = ยึดแถวไว้เอง ไม่งั้น currentTopic เป็น null
      // แล้วแถบล็อก/ปุ่ม "จองห้อง" หายไปทั้งแถบ
      self.detachedCurrentTopic = self.topic.some(t => t.topicID === id) ? null : { ...selectedUser };
      self.currentTopicId = id
      self.messages = []
      let userShowname = (socialType == "Facebook" ? "Facebook" : selectedUser.displayName);
      self.user = userShowname;
      self.loadingUsername = false;

      if (self.Axios_ControllerTopic != null) {
        self.Axios_ControllerTopic.abort();
        self.Axios_ControllerTopic = null;
        await self.UserSelect(id, "");
        if (self.debug) console.log("[ChatService] Abort");
        return;
      } else {
        self.Axios_ControllerTopic = new AbortController();
      }
      self.flagGetTopic = true;
      let data = {
        TopicID: self.currentTopicId,
        USER_CHANNEL: selectedUser.userChannel,
        ID: 0,
        Take: 5
      };
      let Config = {
        signal: self.Axios_ControllerTopic.signal
      }
      self.$call.GetHistoryMessage(
        data,
        Config,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            self.StartupLoadingMessage = false;
            self.Axios_ControllerTopic = null;
            self.flagGetTopic = false;
            var historyList = dataResponse.data.data;
            const IncomingMsg = JSON.stringify(historyList);
            const currentMsg = JSON.stringify(self.messages);
            if (self.currentTopicId > 0) {
              // 🔴 list ถูกโหลดใหม่ได้ระหว่างรอ response — เดิมอ่าน .unread ของ undefined แล้ว throw
              //    กลางคอลแบ็ก ⇒ messages ไม่ถูก push, loadingMessage ค้าง true, จอแชทว่างถาวร
              const currentRow = self.findTopicRow(self.currentTopicId);
              if (currentRow) {
                if (currentRow.unread == true) {
                  self.MarkAsRead(self.currentTopicId);
                }
                currentRow.unread = false;
              }
            }
            // this.TopicUnread();
            if (currentMsg === IncomingMsg) {
              self.loadingMessage = false;
              self.flagTopHistory = true;
              self.showReloadButton = true;
              return IncomingMsg
            }
            else {
              if (historyList != null && historyList.length > 0) {
                historyList.forEach(history => {
                  self.messages.push(history)
                });
              }
              self.showReloadButton = false;
              self.scrollToBottom()
            }
            self.loadingMessage = false;
            self.flagTopHistory = true;
            if (self.debug) console.log("[ChatService] currentTopicId:", self.currentTopicId);
            self.joinCurrentTopic();
            // console.log("JoinChat:", id);
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            })
            self.loadingMessage = false;
          }
        }, (errorResource) => {
          console.error(errorResource);
          self.loadingMessage = false;
        }
      )
    },
    GetHistoryMessage() {
      let self = this;
      if (self.loadingMessage == true) {
        return;
      }
      self.loadingMessage = true
      const TopicID = self.currentTopicId;
      const Log_History_ID = self.Log_History_ID;
      const Log_History_Take = self.Log_History_Take;

      const element = self.$refs.scrollContainer
      const scrollPosition = element.scrollHeight
      let data = {
        TopicID: TopicID,
        // USER_CHANNEL: self.$root.User_Id,
        ID: Log_History_ID,
        Take: Log_History_Take
      };

      self.Axios_ControllerTopic = new AbortController();
      let Config = {
        signal: self.Axios_ControllerTopic.signal
      }
      self.$call.GetHistoryMessage(
        data,
        Config,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            var historyList = dataResponse.data.data;
            if (historyList.length > 0) {
              self.messages = historyList.concat(self.messages);
            } else {
              self.flagTopHistory = false;
            }
            setTimeout(() => {
              const el = self.$refs.scrollContainer;
              el.scrollTop = el.scrollHeight - scrollPosition - 10;
            }, 1);

            self.loadingMessage = false;
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            })
            self.loadingMessage = false;
          }
          self.Axios_ControllerTopic = null
        }, (errorResource) => {
          console.error(errorResource);
          self.loadingMessage = false;
        }
      )
    },

    ChatScreScroll() {
      const self = this;
      const element = self.$refs.scrollContainer;

      if (!element) return;

      if (element.scrollTop <= element.scrollHeight &&
        element.scrollTop <= 0 &&
        self.loadingMessage === false &&
        self.flagTopHistory) {
        if (self.messages.length > 0) {
          self.Log_History_ID = self.messages[0].id;
          self.GetHistoryMessage();
        }
      }
    },
    TopicScroll(e) {
      const self = this;
      const element = e.target;

      if (!element) return;

      if (Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 1 &&
        !self.loadingTopic &&
        self.flagloadingTopic) {
        if (self.topic.length > 0) {
          self.GetTopicAll("scroll");
        }
      }
    },
    async UserChange(id, socialType) {
      let self = this;
      // ตรวจสอบสถานะการเชื่อมต่อก่อนส่งคำสั่ง
      if (!signalRService.connected) {
        try {
          await signalRService.connect(self.username, self.roleId?.toString() || '0');
        } catch (err) {
          console.error("Disconnect:", err);
          return;
        }
      }
      await self.joinCurrentTopic();

      try {
        await signalRService.invoke("Disconnection", signalRService.connectionId, self.currentTopicId);
      } catch (err) {
        console.error(err);
      }

      // await self.connection.invoke("Disconnection", self.connection.connectionId, self.currentTopicId)
      await self.UserSelect(id, socialType);
    },
    MarkAsRead(topicId) {
      let self = this;
      let id = { ID: topicId }
      self.$call.MarkAsRead(id,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            // console.log("MarkAsRead");   
          }
        },
        (errorResource) => {
          console.error("Error: ", errorResource)
        })
    },
    async reloadMessages() {
      let self = this;
      if (!self.currentTopicId || !self.user) {
        console.warn("Cannot reload: No topic or user selected");
        return;
      }
      if (self.loadingMessage) {
        return;
      }
      
      // บันทึก currentTopicId เพื่อใช้หลัง GetTopicAll เสร็จ
      const topicIdToReload = self.currentTopicId;
      // เก็บแถวของห้องไว้ก่อนโหลด list ใหม่ เผื่อมันหลุดหน้าแรก จะได้ยังเปิดค้างไว้ได้
      const foundRowBeforeReload = self.findTopicRow(topicIdToReload);
      const rowBeforeReload = foundRowBeforeReload ? { ...foundRowBeforeReload } : null;
      
      // เรียก GetTopicAll — keepSelection กันมันเด้งไปห้องแรกทับห้องที่เปิดอยู่
      self.GetTopicAll("search", true);
      
      // รอให้ GetTopicAll ทำงานเสร็จโดยตรวจสอบ loadingTopic
      await new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (!self.loadingTopic) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
        
        // Timeout safety หลัง 10 วินาที
        setTimeout(() => {
          clearInterval(checkInterval);
          resolve();
        }, 10000);
      });
      
      // หลังจาก GetTopicAll เสร็จแล้ว เลือกห้องเดิมกลับมาจาก list ที่มันอยู่จริง
      if (self.myLockedTopics.some(t => t.topicID === topicIdToReload)) {
        await self.UserSelectFromMyLocked(topicIdToReload, "");
      } else if (self.topic.some(t => t.topicID === topicIdToReload)) {
        await self.UserSelect(topicIdToReload, "");
      } else if (rowBeforeReload) {
        // ห้องหลุดจากหน้าแรกของ list (BAL เรียงตาม UpdateDate + Skip/Take) — ไม่ใช่ "ห้องหาย"
        // ยึดแถวเดิมไว้เป็น detachedCurrentTopic ซึ่งเป็นกลไกของหน้านี้อยู่แล้ว แล้วเปิดต่อตามปกติ
        self.detachedCurrentTopic = { ...rowBeforeReload };
        await self.UserSelect(topicIdToReload, "");
      } else {
        console.warn(`Topic ${topicIdToReload} not found after reload`);
      }
    },
    // Handler for TopicUnread SignalR event - updates unread badge counts
    // handleTopicUnread() {
    //   let self = this;
    //   self.$call.GetTopicUnread(
    //     (dataResponse) => {
    //       if (dataResponse.status === 0) {
    //         var countUnreads = dataResponse.data;
    //         self.tabSocialType = self.tabSocialType.map(item => {
    //           if (item.value === "All") {
    //             // คำนวณผลรวมทั้งหมดของ unreadCount จาก countUnreads
    //             const total = countUnreads.reduce((sum, curr) => sum + curr.unreadCount, 0);
    //             return { ...item, unreadCount: total };
    //           } else {
    //             // ค้นหาข้อมูลใน countUnreads ที่ socialType ตรงกับ text ของ tabSocialType
    //             const match = countUnreads.find(x => x.socialType === item.value);
    //             return { ...item, unreadCount: match ? match.unreadCount : 0 };
    //           }
    //         });
    //         const newUnreadCount = self.tabSocialType.find(x => x.value === "All").unreadCount;

    //         // Start flashing if new messages arrived (sound is handled by NavBar)
    //         if (newUnreadCount > self.previousUnreadCount) {
    //           if (document.hidden) {
    //             // Tab not focused: start flashing favicon
    //             self.startFlashing(newUnreadCount);
    //           }
    //         }
    //         else if (newUnreadCount === 0) {
    //           // No unread messages: stop flashing and reset title
    //           self.stopFlashing();
    //           self.updateTabTitle(0);
    //         }

    //         // Update tab title with unread count (only if not flashing)
    //         if (!self.flashInterval) {
    //           self.updateTabTitle(newUnreadCount);
    //         } else {
    //           // Update flash count if already flashing
    //           self.flashCount = newUnreadCount;
    //         }

    //         self.previousUnreadCount = newUnreadCount;
    //         // self.unreadCount = newUnreadCount;
    //       }
    //     },
    //     (errorResource) => {
    //       console.error("[ChatService] TopicUnread error:", errorResource);
    //     }
    //   );
    // },

    formatResponseTime() {
      const date = new Date();
      const day = date.getDate().toString().padStart(2, '0');
      const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      const month = monthNames[date.getMonth()];

      // Get hours and minutes
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      // Format: "21 OCT 17:54"
      return `${day} ${month} ${hours}:${minutes}`;
    },
  },
};
</script>

<style scoped>
:deep(#V_markDown) {
  /* display: block; */
  display: grid;
}

:deep(#V_markDown p) {
  margin: 0;
  /* display: contents; */
  display: block;
}

:deep(#V_markDown table) {
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: gray;
  display: table;
  text-indent: 0;
  color: #2b2b2b !important;
}

:deep(#V_markDown tr) {
  border-top: 1px solid #c6cbd1;
  background: #fff;
}

:deep(#V_markDown td,
  #V_markDown th) {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}

:deep(#V_markDown table tr):nth-child(2n) {
  background: #d8d9da;
}

:deep(#V_markDown li code),
:deep(#V_markDown p code) {
  background-color: transparent;
  color: blue;
}

:deep(#V_markDown code.language-markdown),
:deep(#V_markDown pre code) {
  display: block;
  background: #2b2b2b;
  color: #f0f8ff;
  border: 6px, double, white;
}

:deep(#V_markDown code) {
  white-space: pre-wrap;
  background: #2b2b2b;
  color: #f0f8ff;
}

:deep(#V_markDown pre code) {
  margin: 10px 0px;
}

:deep(#V_markDown img) {
  max-width: 100%;
  max-height: 320px
}

:deep(#V_markDown ul.contains-task-list li) {
  margin-top: -20px
}

:deep(#V_markDown br) {
  content: "";
  margin: 0;
  display: block;
  font-size: 24%;
}

:deep(#V_markDown li) {
  margin-top: -1em;
}


:deep(#V_markDown li p) {

  margin-top: -22px;
}

:deep(#V_markDown li p strong) {
  margin-top: -22px;
  display: block;
}




:deep(#V_markDown ul) {
  margin-bottom: -20px;
}

:deep(#V_markDown ol li ul) {
  margin-bottom: -40px;
}

/* #V_markDown h1{
    padding-top: 6px;
  } */
:deep(#V_markDown h1,
  #V_markDown h2,
  #V_markDown h3,
  #V_markDown h4,
  #V_markDown h5) {
  /* padding-top: 15px; */

  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

:deep(#V_markDown ol) {
  margin-bottom: -25px;
}

:deep(#V_markDown blockquote) {
  margin-top: -35px
}

:deep(#V_markDown .container) {
  margin-top: 0px;
}



.user-box {
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.view-height {
  height: var(--responsiveSizeH);
  max-height: calc(var(--responsiveSizeH) - 30px);
}

.scrollable {
  /* max-height: 400px; Adjust height as needed */
  overflow-y: auto;
}

.v-input .v-input__prepend-outer {
  margin: 0px !important;
  margin-top: 0px !important;
}

:deep(textarea#chat-compose-input) {
  max-height: 7rem;
  overflow: auto;
}

/* .badge {
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 5px 10px;
    border-radius: 50%;
    background-color: red;
    color: white;
  } */
/* .chat-box {
    padding: 10px;
    margin-bottom: 10px;
    background-color: #e0e0e0;
    border-radius: 8px;
  } */

.message {
  border-radius: 15px;
}

.markdown-content :deep(p) {
  margin-bottom: 0px !important;
}


/* Chat input container styles */
.chat-input-container {
  padding: 16px;
  background: linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 24px 24px 0 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  position: relative;
}

/* File preview section */
.file-preview-section {
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.file-preview-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.file-preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 80px;
}

.file-preview-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.file-preview-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.file-preview-image {
  border-radius: 10px;
}

.file-preview-overlay {
  position: absolute;
  top: -4px;
  right: -4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.file-preview-card:hover .file-preview-overlay {
  opacity: 1;
}

.file-remove-btn {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3) !important;
}

.file-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.add-more-btn {
  width: 60px !important;
  height: 60px !important;
  border: 2px dashed #e0e0e0 !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
}

.add-more-btn:hover {
  border-color: var(--v-primary-base) !important;
  background-color: rgba(var(--v-theme-primary), 0.04) !important;
}

/* Input wrapper */
.input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background: white;
  border-radius: 28px;
  padding: 8px;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}

/* Action buttons */
.input-action-btn {
  flex-shrink: 0;
  color: #666 !important;
  transition: all 0.2s ease !important;
  border-radius: 20px !important;
}

.input-action-btn:hover {
  background-color: rgba(var(--v-theme-primary), 0.08) !important;
  color: var(--v-primary-base) !important;
  transform: scale(1.05);
}

.attachment-btn:hover {
  color: #2196F3 !important;
}

.emoji-btn:hover {
  color: #FF9800 !important;
}

/* Text input container */
.text-input-container {
  flex: 1;
  min-width: 0;
}

/* Input styles */
:deep(.chat-input .v-field) {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  border-radius: 20px !important;
}

:deep(.chat-input .v-field__field) {
  padding: 12px 16px !important;
}

:deep(.chat-input .v-field__outline) {
  display: none !important;
}

:deep(.chat-input textarea) {
  font-size: 16px !important;
  line-height: 1.5 !important;
  resize: none !important;
  max-height: 120px !important;
}

:deep(.chat-input .v-field__input) {
  min-height: 24px !important;
  padding: 0 !important;
  mask-image: none !important;
}

:deep(.chat-input .v-input__details) {
  display: none !important;
}

/* Input actions */
.input-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* Send button */
.send-btn {
  min-width: 48px !important;
  height: 48px !important;
  border-radius: 24px !important;
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary), 0.3) !important;
  transition: all 0.2s ease !important;
}

.send-btn:not(.loading):not(:disabled) {
  animation: pulse 2s infinite;
}

.send-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(var(--v-theme-primary), 0.4) !important;
}

.send-btn:disabled {
  opacity: 0.5 !important;
  box-shadow: none !important;
}

.send-btn.loading {
  animation: none;
}

/* Animations */
@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}

:deep(.mdi-spin) {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .chat-input-container {
    padding: 12px;
    border-radius: 20px 20px 0 0;
  }

  .input-wrapper {
    gap: 8px;
    padding: 6px;
    border-radius: 24px;
  }

  .input-action-btn {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
  }

  .send-btn {
    min-width: 44px !important;
    height: 44px !important;
    border-radius: 22px !important;
  }

  .file-preview-section {
    margin-bottom: 12px;
    padding: 8px;
  }

  .file-preview-grid {
    gap: 8px;
  }
}



/* ChatService input container styles */
.chatservice-input-container {
  width: 100%;
}

/* ChatService file preview section */
.chatservice-file-preview-section {
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.chatservice-file-preview-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.chatservice-file-preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 80px;
}

.chatservice-file-preview-card {
  position: relative;
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.chatservice-file-preview-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.chatservice-file-preview-image {
  border-radius: 10px;
}

.chatservice-file-preview-overlay {
  position: absolute;
  top: -6px;
  right: -6px;
}

.chatservice-file-remove-btn {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  opacity: 1;
}

.chatservice-file-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.chatservice-add-more-btn {
  width: 60px !important;
  height: 60px !important;
  border: 2px dashed #e0e0e0 !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
}

.chatservice-add-more-btn:hover {
  border-color: var(--v-primary-base) !important;
  background-color: rgba(var(--v-theme-primary), 0.04) !important;
}

/* ChatService input wrapper */
.chatservice-input-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border-radius: 28px;
  padding: 8px;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}

.chatservice-input-wrapper:focus-within {
  box-shadow:
    0 8px 32px rgba(var(--v-theme-primary), 0.15),
    0 2px 8px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border-color: rgba(var(--v-theme-primary), 0.3);
}

/* ChatService action buttons */
.chatservice-input-action-btn {
  flex-shrink: 0;
  color: #666 !important;
  transition: all 0.2s ease !important;
  border-radius: 20px !important;
}

.chatservice-input-action-btn:hover {
  background-color: rgba(var(--v-theme-primary), 0.08) !important;
  color: var(--v-primary-base) !important;
  transform: scale(1.05);
}

.chatservice-attachment-btn:hover {
  color: #2196F3 !important;
}

.chatservice-emoji-btn:hover {
  color: #FF9800 !important;
}

/* ChatService text input container */
.chatservice-text-input-container {
  flex: 1;
  min-width: 0;
}

/* ChatService input styles */
:deep(.chatservice-chat-input .v-field) {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  border-radius: 20px !important;
}

:deep(.chatservice-chat-input .v-field__field) {
  padding: 12px 16px !important;
}

:deep(.chatservice-chat-input .v-field__outline) {
  display: none !important;
}

:deep(.chatservice-chat-input textarea) {
  font-size: 16px !important;
  line-height: 1.5 !important;
  resize: none !important;
  max-height: 120px !important;
}

:deep(.chatservice-chat-input .v-field__input) {
  min-height: 24px !important;
  padding: 0 !important;
  mask-image: none !important;
}

:deep(.chatservice-chat-input .v-input__details) {
  display: none !important;
}

/* ChatService input actions */
.chatservice-input-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* ChatService send button */
.chatservice-send-btn {
  min-width: 48px !important;
  height: 48px !important;
  border-radius: 24px !important;
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary), 0.3) !important;
  transition: all 0.2s ease !important;
}

.chatservice-send-btn:not(.chatservice-loading):not(:disabled) {
  animation: chatservice-pulse 2s infinite;
}

.chatservice-send-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(var(--v-theme-primary), 0.4) !important;
}

.chatservice-send-btn:disabled {
  opacity: 0.5 !important;
  box-shadow: none !important;
}

.chatservice-send-btn.chatservice-loading {
  animation: none;
}

/* ChatService animations */
@keyframes chatservice-pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}

:deep(.mdi-spin) {
  animation: chatservice-spin 1s linear infinite;
}

@keyframes chatservice-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* ChatService responsive design */
@media (max-width: 768px) {
  .chatservice-input-container {
    padding: 12px;
    border-radius: 20px 20px 0 0;
  }

  .chatservice-input-wrapper {
    gap: 8px;
    padding: 6px;
    border-radius: 24px;
  }

  .chatservice-input-action-btn {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
  }

  .chatservice-send-btn {
    min-width: 44px !important;
    height: 44px !important;
    border-radius: 22px !important;
  }

  .chatservice-file-preview-section {
    margin-bottom: 12px;
    padding: 8px;
  }

  .chatservice-file-preview-grid {
    gap: 8px;
  }
}

.chatservice-topic-list-container {
  height: 100% !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

/* Fade out animation for topics switching to Bot */
.chatservice-fade-out {
  animation: chatservice-fadeOutSlide 0.5s ease-out forwards;
  pointer-events: none;
}

@keyframes chatservice-fadeOutSlide {
  0% {
    opacity: 1;
    transform: translateX(0);
    max-height: 100px;
  }
  70% {
    opacity: 0;
    max-height: 100px;
  }
  100% {
    opacity: 0;
    transform: translateX(-10px);
    max-height: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
}

/* Fade in animation for new topics */
.chatservice-fade-in {
  animation: chatservice-fadeInSlide 0.5s ease-out forwards;
}

@keyframes chatservice-fadeInSlide {
  0% {
    opacity: 0;
    transform: translateX(-30px);
    max-height: 0;
  }
  30% {
    max-height: 100px;
  }
  100% {
    opacity: 1;
    transform: translateX(0);
    max-height: 100px;
  }
}

.chatservice-topic-list-group {
  height: 100% !important;
  flex: 1 1 auto !important;
  overflow: hidden !important;
}

.chatservice-topic-virtual-scroll {
  background: transparent;
  height: 100% !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  border-radius: 12px;
}

/* แก้ไข v-virtual-scroll internal container */
:deep(.chatservice-topic-virtual-scroll .v-virtual-scroll__container) {
  overflow-y: auto !important;
  height: 100% !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--v-theme-primary), 0.3) rgba(0, 0, 0, 0.04);
  border-radius: 12px;
}

/* เพิ่ม scrollbar styles สำหรับ webkit browsers */
:deep(.chatservice-topic-virtual-scroll .v-virtual-scroll__container::-webkit-scrollbar) {
  width: 12px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
}

/* Fix skeleton loader container */
:deep(.v-skeleton-loader.fill-height) {
  min-height: 0 !important;
  height: 90% !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Flex layout for v-card-text containing topic list + locked section */
.chatservice-card-text-flex {
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

/* Wrapper div takes remaining space in flex parent */
.chatservice-skeleton-flex {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Skeleton loader inner: when loading shows bones div, when not loading renders Fragment (no wrapper) */
/* So the v-list becomes direct child of .chatservice-skeleton-flex */
.chatservice-skeleton-flex > .v-skeleton-loader {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

.chatservice-skeleton-flex > .v-list {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

.chatservice-topic-item-wrapper {
  background: transparent;
}

.chatservice-topic-list-item {
  border-radius: 10px;
  margin-bottom: 2px;
  transition: background 0.15s, border-left 0.15s;
  cursor: pointer;
  min-height: 67px;
  padding: 8px 12px;
}

.chatservice-topic-list-item:hover {
  background: rgba(var(--v-theme-primary), 0.06);
}

/* Selected/Active topic highlight */
.chatservice-topic-selected,
.chatservice-topic-list-item.v-list-item--active {
  background: rgba(var(--v-theme-primary), 0.12) !important;
  border-left: 4px solid rgb(var(--v-theme-primary));
}

/* My Locked Topics Section Styles */
.chatservice-my-locked-section {
  /* border: 1px solid #c8e6c9; */
  border-radius: 8px;
  background: #fafafa;
}

.chatservice-my-locked-list {
  overflow-y: auto;
  border-radius: 0 0 8px 8px;
  /* max-height is now set dynamically via :style binding */
}

.chatservice-my-locked-list::-webkit-scrollbar {
  width: 6px;
}

.chatservice-my-locked-list::-webkit-scrollbar-thumb {
  background: #a5d6a7;
  border-radius: 3px;
}

.chatservice-my-locked-list::-webkit-scrollbar-track {
  background: #e8f5e9;
}

.chatservice-topic-badge {
  margin-right: 8px;
}

:deep(.chatservice-topic-badge .v-badge__badge) {
  border-radius: 50% !important;
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.chatservice-topic-badge .v-badge__badge .v-icon) {
  font-size: 12px !important;
}

.chatservice-topic-avatar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.chatservice-topic-title {
  font-weight: 600;
  font-size: 15px;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.chatservice-topic-subtitle {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.chatservice-topic-switch {
  margin-left: 8px;
}

.chatservice-topic-divider {
  margin: 0 0 0 60px;
  border-color: #eee;
}

/* Responsive */
@media (max-width: 768px) {
  .chatservice-topic-list-item {
    padding: 6px 6px;
    min-height: 56px;
  }

  .chatservice-topic-title {
    font-size: 14px;
  }

  .chatservice-topic-subtitle {
    font-size: 12px;
    max-width: 100px;
  }
}

.chatservice-switch-wrapper {
  transform: scale(1);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 90px;
}

.chatservice-topic-switch {
  margin-left: 0;
  padding: 0 2px;
  --v-switch-thumb-size: 18px;
  --v-switch-track-width: 34px;
  --v-switch-track-height: 18px;
  --v-switch-track-opacity: 0.15;
  --v-switch-track-border-radius: 9px;
}

:deep(.chatservice-topic-switch .v-selection-control__input) {
  min-width: 34px !important;
}

.chatservice-switch-label {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.1px;
  transition: color 0.2s;
}

.chatservice-switch-label-left {
  flex-direction: row-reverse !important;
  justify-content: flex-end !important;
}

:deep(.chatservice-switch-label-left .v-selection-control__wrapper) {
  order: 2;
  margin-left: 8px;
  margin-right: 0;
}

:deep(.chatservice-switch-label-left .v-label) {
  order: 1;
  margin-right: 8px;
  margin-left: 0;
  display: flex;
  align-items: center;
}

.chatservice-switch-label.is-admin {
  color: var(--v-theme-primary);
}

.chatservice-switch-label.is-bot {
  color: #888;
}

@media (max-width: 768px) {
  .chatservice-switch-label {
    font-size: 12px;
  }

  .chatservice-switch-wrapper {
    min-width: 70px;
  }
}

/* ChatService Custom Scrollbar */
.chatservice-scrollable {
  overflow-y: auto !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--v-theme-primary), 0.3) transparent;
}

/* Webkit Scrollbar (Chrome, Safari, Edge) */
.chatservice-scrollable::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.chatservice-scrollable::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  margin: 4px 0;
}

.chatservice-scrollable::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-primary), 0.3);
  border-radius: 4px;
  transition: all 0.2s ease;
}

.chatservice-scrollable::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-primary), 0.5);
  transform: scale(1.1);
}

.chatservice-scrollable::-webkit-scrollbar-thumb:active {
  background: rgba(var(--v-theme-primary), 0.7);
}

.chatservice-scrollable::-webkit-scrollbar-corner {
  background: transparent;
}

/* Virtual Scroll Container Override */
:deep(.chatservice-scrollable .v-virtual-scroll__container) {
  overflow-y: auto !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--v-theme-primary), 0.3) transparent;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar) {
  width: 8px;
  height: 8px;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  margin: 4px 0;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-thumb) {
  background: rgba(var(--v-theme-primary), 0.3);
  border-radius: 4px;
  transition: all 0.2s ease;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-thumb:hover) {
  background: rgba(var(--v-theme-primary), 0.5);
  transform: scale(1.1);
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-thumb:active) {
  background: rgba(var(--v-theme-primary), 0.7);
}

/* Logo image contain style */
:deep(.logo-contain .v-img__img) {
  object-fit: contain !important;
}

/* Reload overlay styles - Liquid Glass */
.reload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.reload-glass-btn {
  width: 56px !important;
  height: 56px !important;
  background: rgba(255, 255, 255, 0.25) !important;
  backdrop-filter: blur(20px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  border-radius: 50% !important;
  box-shadow: 
    0 4px 30px rgba(0, 0, 0, 0.08),
    inset 0 1px 1px rgba(255, 255, 255, 0.6) !important;
  color: rgba(0, 0, 0, 0.6) !important;
  transition: all 0.3s ease !important;
}

.reload-glass-btn:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 8px 40px rgba(0, 0, 0, 0.12),
    inset 0 1px 1px rgba(255, 255, 255, 0.8) !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* ============================================
   Lock Feature Styles
   ============================================ */

/* Topic list lock overlay - DISABLED (no longer using blur effect) */
/* .chatservice-topic-locked {
  position: relative;
} */

/* Blur layer using pseudo-element to keep badge sharp - DISABLED */
/* .chatservice-topic-locked::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  background: rgba(255, 255, 255, 0.3);
  z-index: 1;
  pointer-events: none;
} */

/* .chatservice-topic-lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 10;
} */

/* Lock badge styling - still used in new chip design */
.chatservice-lock-badge {
  font-weight: 600;
  text-transform: none;
  pointer-events: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(0);
}

/* Lock notification bars (replacing input area) */
.chatservice-lock-bar {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-radius: 12px;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  width: 100%;
}

.chatservice-lock-bar-default {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.1) 0%, rgba(33, 150, 243, 0.05) 100%);
  border: 2px solid rgba(33, 150, 243, 0.3);
  color: #1976d2;
}

.chatservice-lock-bar-warning {
  background: linear-gradient(135deg, rgba(255, 152, 0, 0.1) 0%, rgba(255, 152, 0, 0.05) 100%);
  border: 2px solid rgba(255, 152, 0, 0.3);
  color: #f57c00;
}

.chatservice-lock-bar strong {
  font-weight: 700;
}

.chatservice-status-card {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 14px;
  padding: 16px 20px;
  border-radius: 12px;
}

.chatservice-status-card-closed {
  background: linear-gradient(135deg, rgba(97, 97, 97, 0.12) 0%, rgba(117, 117, 117, 0.06) 100%);
  border: 1px solid rgba(97, 97, 97, 0.22);
  color: #424242;
}

.chatservice-status-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: rgba(97, 97, 97, 0.14);
  flex-shrink: 0;
}

.chatservice-status-card-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.chatservice-status-card-title {
  font-size: 14px;
  font-weight: 700;
}

.chatservice-status-card-subtitle {
  font-size: 13px;
  color: #616161;
}

/* Lock banner styles */
:deep(.v-alert.ma-2.mb-0) {
  border-radius: 8px;
}

:deep(.chatservice-lock-alert) {
  min-height: auto;
  overflow: visible;
}

.reload-glass-btn:hover {
  background: rgba(255, 255, 255, 0.35) !important;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.12),
    inset 0 1px 1px rgba(255, 255, 255, 0.8) !important;
  transform: scale(1.05);
}

.reload-glass-btn:active {
  transform: scale(0.95);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* Filter Dropdown Styles */
.chatservice-filter-dropdown {
  max-width: 100%;
  min-width: 200px;
}

.chatservice-filter-dropdown :deep(.v-field) {
  border-radius: 8px;
}

.chatservice-filter-dropdown :deep(.v-field__input) {
  padding: 4px 8px;
  min-height: 36px;
}

/* Header Switch Styles */
.chatservice-header-switch {
  display: flex;
  align-items: center;
}

.chatservice-header-switch :deep(.v-switch) {
  width: auto;
  min-width: 100px;
}

.chatservice-header-switch :deep(.v-switch__track) {
  height: 20px;
  width: 40px;
}

.chatservice-header-switch :deep(.v-switch__thumb) {
  width: 16px;
  height: 16px;
}

.chatservice-header-switch .chatservice-switch-label {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
</style>